module.exports = {
	"F00000Q7RQ": {
		"fund_id": "FS0000A9US",
		"investment_vehicle_name": "Fidelity MSCI Consumer Discret ETF",
		"ticker": "FDIS",
		"portfolio_date": "2025-03-29",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity MSCI Consumer Discretionary Index ETF",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9955813925426988,
		"percent_rated_long": 0.9955813925426988,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 2,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000Q7RW": {
		"fund_id": "FS0000A9UX",
		"investment_vehicle_name": "Fidelity MSCI Communication ServicesETF",
		"ticker": "FCOM",
		"portfolio_date": "2025-03-29",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity MSCI Communication Services Index ETF",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9963252912121426,
		"percent_rated_long": 0.9963252912121426,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000Q7RX": {
		"fund_id": "FS0000A9UY",
		"investment_vehicle_name": "Fidelity MSCI Information Tech ETF",
		"ticker": "FTEC",
		"portfolio_date": "2025-03-29",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity MSCI Information Technology Index ETF",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9961770099208275,
		"percent_rated_long": 0.9961770099208275,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000Q7RY": {
		"fund_id": "FS0000A9UZ",
		"investment_vehicle_name": "Fidelity MSCI Health Care ETF",
		"ticker": "FHLC",
		"portfolio_date": "2025-03-29",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity MSCI Health Care Index ETF",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9960782662756485,
		"percent_rated_long": 0.9960782662756485,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000W4CI": {
		"fund_id": "FS0000C0O1",
		"investment_vehicle_name": "The Real Estate Select Sector SPDR®",
		"ticker": "XLRE",
		"portfolio_date": "2025-03-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "The Real Estate Select Sector SPDR® Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9935564587128561,
		"percent_rated_long": 0.9935564587128561,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FEUSA04ADG": {
		"fund_id": "FSUSA000I3",
		"investment_vehicle_name": "Vanguard FTSE Emerging Markets ETF",
		"ticker": "VWO",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Emerging Markets Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9700063913890278,
		"percent_rated_long": 0.9700621931989674,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FEUSA04AC5": {
		"fund_id": "FSUSA002PU",
		"investment_vehicle_name": "Vanguard Growth ETF",
		"ticker": "VUG",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9993052406920615,
		"percent_rated_long": 0.9993052406920615,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FEUSA04AC4": {
		"fund_id": "FSUSA002PV",
		"investment_vehicle_name": "Vanguard Value ETF",
		"ticker": "VTV",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9983908498675275,
		"percent_rated_long": 0.9983908498675275,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FEUSA04ACH": {
		"fund_id": "FSUSA0032Z",
		"investment_vehicle_name": "Vanguard Small-Cap Value ETF",
		"ticker": "VBR",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.990702364144645,
		"percent_rated_long": 0.990702364144645,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FEUSA04AC6": {
		"fund_id": "FSUSA003FZ",
		"investment_vehicle_name": "Vanguard Small-Cap Growth ETF",
		"ticker": "VBK",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9898907749237138,
		"percent_rated_long": 0.9898907749237138,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA06JJS": {
		"fund_id": "FSUSA004S1",
		"investment_vehicle_name": "Vanguard FTSE Developed Markets ETF",
		"ticker": "VEA",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Developed Markets Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9745225453048421,
		"percent_rated_long": 0.9747477986602471,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FEUSA00001": {
		"fund_id": "FSUSA00B4A",
		"investment_vehicle_name": "SPDR® S&P 500® ETF Trust",
		"ticker": "SPY",
		"portfolio_date": "2025-03-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "SPDR® S&P 500® ETF Trust",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9969181808501235,
		"percent_rated_long": 0.9969181808501235,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FEUSA0002W": {
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_name": "iShares MSCI EAFE ETF",
		"ticker": "EFA",
		"portfolio_date": "2025-03-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9690280435611428,
		"percent_rated_long": 0.9789673651824844,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FEUSA04AHK": {
		"fund_id": "FSUSA076I8",
		"investment_vehicle_name": "Vanguard Mid-Cap Value ETF",
		"ticker": "VOE",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid-Cap Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9990425351967621,
		"percent_rated_long": 0.9990425351967621,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FEUSA04AHL": {
		"fund_id": "FSUSA076IB",
		"investment_vehicle_name": "Vanguard Mid-Cap Growth ETF",
		"ticker": "VOT",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid-Cap Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9974865449174393,
		"percent_rated_long": 0.9974865449174393,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F000014AX4": {
		"fund_id": "FS0000FNM2",
		"investment_vehicle_name": "State Street Target Retirement 2065 K",
		"ticker": "SSFKX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2065 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.8528282411174054,
		"percent_rated_long": 0.8528282411174054,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000V3SK": {
		"fund_id": "FS0000BKUG",
		"investment_vehicle_name": "Baillie Gifford International Alpha 3",
		"ticker": "BGIFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Baillie Gifford International Alpha Fund",
		"fund_family_label": "Baillie Gifford Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.987291049686938,
		"percent_rated_long": 0.987291049686938,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 2
	},
	"F00000Q0L5": {
		"fund_id": "FSUSA004KP",
		"investment_vehicle_name": "Allspring Special Mid Cap Value R6",
		"ticker": "WFPRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Allspring Special Mid Cap Value Fund",
		"fund_family_label": "Allspring Global Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9686192873958104,
		"percent_rated_long": 0.9686192873958104,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00L8W": {
		"fund_id": "FSUSA002QH",
		"investment_vehicle_name": "Vanguard 500 Index Admiral",
		"ticker": "VFIAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard 500 Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9993150072147243,
		"percent_rated_long": 0.9993150072147243,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FOUSA00FTH": {
		"fund_id": "FSUSA002QX",
		"investment_vehicle_name": "Vanguard PRIMECAP Inv",
		"ticker": "VPMCX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard PrimeCap Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9859718630668972,
		"percent_rated_long": 0.9863234118824927,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 3
	},
	"FOUSA02TYD": {
		"fund_id": "FSUSA002QX",
		"investment_vehicle_name": "Vanguard PRIMECAP Adm",
		"ticker": "VPMAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard PrimeCap Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9859718630668972,
		"percent_rated_long": 0.9863234118824927,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 3
	},
	"FOUSA0583Z": {
		"fund_id": "FSUSA04YSX",
		"investment_vehicle_name": "DFA Global Equity I",
		"ticker": "DGEIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA Global Equity Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9791058173502659,
		"percent_rated_long": 0.9791060765367506,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA02TY7": {
		"fund_id": "FSUSA002RA",
		"investment_vehicle_name": "Vanguard Health Care Adm",
		"ticker": "VGHAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Vanguard Health Care Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9831217285068481,
		"percent_rated_long": 0.9835342111274092,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02TIF": {
		"fund_id": "FSUSA002RC",
		"investment_vehicle_name": "Vanguard US Growth Admiral™",
		"ticker": "VWUAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard US Growth Portfolio",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9725493274548918,
		"percent_rated_long": 0.9728027482044237,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA00FU3": {
		"fund_id": "FSUSA002RE",
		"investment_vehicle_name": "Vanguard International Growth Inv",
		"ticker": "VWIGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard International Growth Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9594852733410245,
		"percent_rated_long": 0.9657506961300967,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA02TID": {
		"fund_id": "FSUSA002RE",
		"investment_vehicle_name": "Vanguard International Growth Adm",
		"ticker": "VWILX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard International Growth Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9594852733410245,
		"percent_rated_long": 0.9657506961300967,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00FUG": {
		"fund_id": "FSUSA002RN",
		"investment_vehicle_name": "Vanguard Dividend Growth Inv",
		"ticker": "VDIGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Dividend Growth Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9802412060092679,
		"percent_rated_long": 0.9805224568072863,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA06JNJ": {
		"fund_id": "FSUSA08E50",
		"investment_vehicle_name": "DWS RREEF Real Assets Inst",
		"ticker": "AAAZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "DWS RREEF Real Assets Fund",
		"fund_family_label": "DWS",
		"sustainable_investment": 0,
		"percent_rated": 0.7787531897319211,
		"percent_rated_long": 0.7806825963418843,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F000002PIZ": {
		"fund_id": "FSUSA002RR",
		"investment_vehicle_name": "American Funds Washington Mutual R6",
		"ticker": "RWMGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Funds Washington Mutual Investors Fund",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9762035717247253,
		"percent_rated_long": 0.9762035717247253,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FOUSA00FVM": {
		"fund_id": "FSUSA002SA",
		"investment_vehicle_name": "Vanguard Wellington™ Inv",
		"ticker": "VWELX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Wellington™ Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.6553588961372965,
		"percent_rated_long": 0.6556095356151068,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02T18": {
		"fund_id": "FSUSA002SA",
		"investment_vehicle_name": "Vanguard Wellington™ Admiral™",
		"ticker": "VWENX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Wellington™ Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.6553588961372965,
		"percent_rated_long": 0.6556095356151068,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02TYJ": {
		"fund_id": "FSUSA002SE",
		"investment_vehicle_name": "Vanguard Windsor™ Admiral™",
		"ticker": "VWNEX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Windsor Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9781666839785641,
		"percent_rated_long": 0.9789611522706011,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 5,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 2
	},
	"FOUSA02T2O": {
		"fund_id": "FSUSA002SF",
		"investment_vehicle_name": "Vanguard Windsor™ II Admiral™",
		"ticker": "VWNAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Windsor™ II Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9534231819674306,
		"percent_rated_long": 0.9535433957019955,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"FOUSA00FVS": {
		"fund_id": "FSUSA002SF",
		"investment_vehicle_name": "Vanguard Windsor™ II Inv",
		"ticker": "VWNFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Windsor™ II Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9534231819674306,
		"percent_rated_long": 0.9535433957019955,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00000WLTC": {
		"fund_id": "FSUSA002SO",
		"investment_vehicle_name": "Wasatch Small Cap Growth Institutional",
		"ticker": "WIAEX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Wasatch Small Cap Growth Fund®",
		"fund_family_label": "Wasatch",
		"sustainable_investment": 0,
		"percent_rated": 0.9708551580617197,
		"percent_rated_long": 0.9708551580617197,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA06LBG": {
		"fund_id": "FSUSA08GGK",
		"investment_vehicle_name": "Goldman Sachs Intl Sm Cp Insghts Instl",
		"ticker": "GICIX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Goldman Sachs International Small Cap Insights Fund",
		"fund_family_label": "Goldman Sachs",
		"sustainable_investment": 0,
		"percent_rated": 0.9746264333743803,
		"percent_rated_long": 0.9767064356294036,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00BNG": {
		"fund_id": "FSUSA000CU",
		"investment_vehicle_name": "Vanguard Strategic Equity Inv",
		"ticker": "VSEQX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Strategic Equity Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9949723576499805,
		"percent_rated_long": 0.9949723576499805,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000TIA0": {
		"fund_id": "FSUSA000CW",
		"investment_vehicle_name": "AB Discovery Growth Z",
		"ticker": "CHCZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "AB Discovery Growth Fund",
		"fund_family_label": "AllianceBernstein",
		"sustainable_investment": 0,
		"percent_rated": 0.9470755673890189,
		"percent_rated_long": 0.9470755673890189,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000MMTN": {
		"fund_id": "FSUSA001JN",
		"investment_vehicle_name": "MFS Growth R6",
		"ticker": "MFEKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MFS Growth Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.98719872622208,
		"percent_rated_long": 0.98719872622208,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 4
	},
	"FOUSA00KWE": {
		"fund_id": "FSUSA004OJ",
		"investment_vehicle_name": "T. Rowe Price Instl Mid-Cap Equity Gr",
		"ticker": "PMEGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Institutional Mid Cap Equity Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9679180763353485,
		"percent_rated_long": 0.9679180763353485,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA00BP7": {
		"fund_id": "FSUSA000DQ",
		"investment_vehicle_name": "Cohen & Steers Realty Shares L",
		"ticker": "CSRSX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Cohen & Steers Realty Shares Fund",
		"fund_family_label": "Cohen & Steers",
		"sustainable_investment": 0,
		"percent_rated": 0.981868951831131,
		"percent_rated_long": 0.981868951831131,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000JTO4": {
		"fund_id": "FSUSA000EH",
		"investment_vehicle_name": "Columbia Small Cap Value I R",
		"ticker": "CSVRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Columbia Small Cap Value Fund I",
		"fund_family_label": "Columbia Threadneedle",
		"sustainable_investment": 0,
		"percent_rated": 0.9925518598061785,
		"percent_rated_long": 0.9925518598061785,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000ZJYS": {
		"fund_id": "FSUSA05H3F",
		"investment_vehicle_name": "MFS Intl Diversification R6",
		"ticker": "MDIZX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "International Equity Funds",
		"fund_legal_name": "MFS International Diversification Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9784875747877577,
		"percent_rated_long": 0.9784898193643476,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F0000152GG": {
		"fund_id": "FS0000FZ47",
		"investment_vehicle_name": "MFS International Large Cap Value R6",
		"ticker": "MKVHX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "MFS International Large Cap Value Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9858561457398234,
		"percent_rated_long": 0.9858561457398234,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000VOGS": {
		"fund_id": "FS0000BTBW",
		"investment_vehicle_name": "Loomis Sayles Small/Mid Cap Growth Instl",
		"ticker": "LSMIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Loomis Sayles Small/Mid Cap Growth Fund",
		"fund_family_label": "Loomis Sayles Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9719502611324079,
		"percent_rated_long": 0.9719502611324079,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000YDFU": {
		"fund_id": "FS0000BTNM",
		"investment_vehicle_name": "AMG GW&K Small Mid Cap Core Z",
		"ticker": "GWGZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "AMG GW&K Small/Mid Cap Core Fund",
		"fund_family_label": "AMG Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9887609652805608,
		"percent_rated_long": 0.9891294834436916,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000WLFU": {
		"fund_id": "FSUSA004QO",
		"investment_vehicle_name": "BlackRock Mid-Cap Growth Equity K",
		"ticker": "BMGKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "BlackRock Mid-Cap Growth Equity Portfolio",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9951068389608256,
		"percent_rated_long": 0.9951068389608256,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00L29": {
		"fund_id": "FSUSA004QO",
		"investment_vehicle_name": "BlackRock Mid-Cap Growth Equity Instl",
		"ticker": "CMGIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "BlackRock Mid-Cap Growth Equity Portfolio",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9951068389608256,
		"percent_rated_long": 0.9951068389608256,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA05B3E": {
		"fund_id": "FSUSA05H3F",
		"investment_vehicle_name": "MFS Intl Diversification I",
		"ticker": "MDIJX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "International Equity Funds",
		"fund_legal_name": "MFS International Diversification Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9784875747877577,
		"percent_rated_long": 0.9784898193643476,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000PHFU": {
		"fund_id": "FSUSA002WY",
		"investment_vehicle_name": "Loomis Sayles Small Cap Growth N",
		"ticker": "LSSNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Loomis Sayles Small Cap Growth Fund",
		"fund_family_label": "Loomis Sayles Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9652237015561133,
		"percent_rated_long": 0.9652237015561133,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA00DQS": {
		"fund_id": "FSUSA001KS",
		"investment_vehicle_name": "BlackRock Emerging Mkts Instl",
		"ticker": "MADCX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "BlackRock Emerging Markets Fund, Inc.",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.7821366047596465,
		"percent_rated_long": 0.8777368936064249,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA06MDI": {
		"fund_id": "FSUSA08I1W",
		"investment_vehicle_name": "Nuveen Lifecycle 2045 R6",
		"ticker": "TTFIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2045 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.8320501127233926,
		"percent_rated_long": 0.8348889824738094,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F0000155P3": {
		"fund_id": "FS0000G0EV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2065 R",
		"ticker": "RRSUX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2065 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9574153076472062,
		"percent_rated_long": 0.9586594504136723,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F0000155P4": {
		"fund_id": "FS0000G0EV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2065",
		"ticker": "TRSJX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2065 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9574153076472062,
		"percent_rated_long": 0.9586594504136723,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGJY": {
		"fund_id": "FS0000G0EV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2065 I",
		"ticker": "TRMOX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2065 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9574153076472062,
		"percent_rated_long": 0.9586594504136723,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000N8OD": {
		"fund_id": "FS00008YI2",
		"investment_vehicle_name": "Vanguard Target Retirement 2060 Fund",
		"ticker": "VTTSX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2060 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8472834898068844,
		"percent_rated_long": 0.8644837681051801,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA06BY5": {
		"fund_id": "FSUSA004R8",
		"investment_vehicle_name": "Macquarie Emerging Markets R",
		"ticker": "DEMRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Macquarie Emerging Markets Fund",
		"fund_family_label": "Macquarie",
		"sustainable_investment": 0,
		"percent_rated": 0.9942452692956947,
		"percent_rated_long": 0.9959730025958139,
		"grade_fossil": 5,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000X539": {
		"fund_id": "FSUSA004R8",
		"investment_vehicle_name": "Macquarie Emerging Markets R6",
		"ticker": "DEMZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Macquarie Emerging Markets Fund",
		"fund_family_label": "Macquarie",
		"sustainable_investment": 0,
		"percent_rated": 0.9942452692956947,
		"percent_rated_long": 0.9959730025958139,
		"grade_fossil": 5,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA05BPL": {
		"fund_id": "FSUSA000FZ",
		"investment_vehicle_name": "NYLI Winslow Large Cap Growth Class I",
		"ticker": "MLAIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "NYLI Winslow Large Cap Growth Fund",
		"fund_family_label": "New York Life Investment Management LLC",
		"sustainable_investment": 0,
		"percent_rated": 0.9961582088683508,
		"percent_rated_long": 0.9961582088683508,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000PRFP": {
		"fund_id": "FSUSA000FZ",
		"investment_vehicle_name": "NYLI Winslow Large Cap Growth Class R6",
		"ticker": "MLRSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "NYLI Winslow Large Cap Growth Fund",
		"fund_family_label": "New York Life Investment Management LLC",
		"sustainable_investment": 0,
		"percent_rated": 0.9961582088683508,
		"percent_rated_long": 0.9961582088683508,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA05B54": {
		"fund_id": "FSUSA05RFV",
		"investment_vehicle_name": "Fidelity Advisor Small Cap Value I",
		"ticker": "FCVIX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Small Cap Value Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9888091944856163,
		"percent_rated_long": 0.9893079339104036,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA05B4X": {
		"fund_id": "FSUSA05RFV",
		"investment_vehicle_name": "Fidelity Small Cap Value Fund",
		"ticker": "FCPVX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Small Cap Value Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9888091944856163,
		"percent_rated_long": 0.9893079339104036,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA06A8Z": {
		"fund_id": "FSUSA063RL",
		"investment_vehicle_name": "Nuveen Lifecycle 2010 R6",
		"ticker": "TCTIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2010 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.31451191117361466,
		"percent_rated_long": 0.3187058528207684,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06A91": {
		"fund_id": "FSUSA063RM",
		"investment_vehicle_name": "Nuveen Lifecycle 2015 R6",
		"ticker": "TCNIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2015 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.342630064886944,
		"percent_rated_long": 0.3471913146320781,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06A92": {
		"fund_id": "FSUSA063RN",
		"investment_vehicle_name": "Nuveen Lifecycle 2020 R6",
		"ticker": "TCWIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2020 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.3904076611663242,
		"percent_rated_long": 0.3954776852464697,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06A93": {
		"fund_id": "FSUSA063RO",
		"investment_vehicle_name": "Nuveen Lifecycle 2025 R6",
		"ticker": "TCYIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2025 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.4412656253790144,
		"percent_rated_long": 0.446812569119833,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06A94": {
		"fund_id": "FSUSA063RP",
		"investment_vehicle_name": "Nuveen Lifecycle 2030 R6",
		"ticker": "TCRIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2030 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.5276805013938753,
		"percent_rated_long": 0.5334653830906825,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA06A95": {
		"fund_id": "FSUSA063RR",
		"investment_vehicle_name": "Nuveen Lifecycle 2035 R6",
		"ticker": "TCIIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2035 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.6182427809067859,
		"percent_rated_long": 0.6239661839815495,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA06MDR": {
		"fund_id": "FSUSA08I21",
		"investment_vehicle_name": "Nuveen Lifecycle Retire Income R6",
		"ticker": "TLRIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle Retirement Income Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.33902340608589476,
		"percent_rated_long": 0.3435471466464901,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000VV1B": {
		"fund_id": "FS0000BWAJ",
		"investment_vehicle_name": "State Street Small/Mid Cap Equity Idx K",
		"ticker": "SSMKX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "State Street Small/Mid Cap Equity Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9848514304169532,
		"percent_rated_long": 0.9848514304169532,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000VV1D": {
		"fund_id": "FS0000BWAK",
		"investment_vehicle_name": "State Street Small/Mid Cap Equity Index",
		"ticker": "SSMHX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "State Street Small/Mid Cap Equity Index Portfolio",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9848514304169532,
		"percent_rated_long": 0.9848514304169532,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000QKMB": {
		"fund_id": "FSUSA004S1",
		"investment_vehicle_name": "Vanguard Developed Markets Index Ins Pls",
		"ticker": "VDIPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Developed Markets Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9745225453048421,
		"percent_rated_long": 0.9747477986602471,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00L5B": {
		"fund_id": "FSUSA004S1",
		"investment_vehicle_name": "Vanguard Developed Markets Index Admiral",
		"ticker": "VTMGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Developed Markets Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9745225453048421,
		"percent_rated_long": 0.9747477986602471,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA02SN7": {
		"fund_id": "FSUSA004S1",
		"investment_vehicle_name": "Vanguard Developed Markets Index Instl",
		"ticker": "VTMNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Developed Markets Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9745225453048421,
		"percent_rated_long": 0.9747477986602471,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00BWS": {
		"fund_id": "FSUSA000HJ",
		"investment_vehicle_name": "Fidelity Large Cap Stock",
		"ticker": "FLCSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Large Cap Stock Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9669396109364392,
		"percent_rated_long": 0.9674438785353439,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06A96": {
		"fund_id": "FSUSA063RS",
		"investment_vehicle_name": "Nuveen Lifecycle 2040 R6",
		"ticker": "TCOIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Nuveen Lifecycle 2040 Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.7439284322154879,
		"percent_rated_long": 0.7486111202430247,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA06TXE": {
		"fund_id": "FSUSA065WW",
		"investment_vehicle_name": "Fidelity International Discovery K",
		"ticker": "FIDKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity International Discovery Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9611427978833917,
		"percent_rated_long": 0.9616433436226899,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000NBB3": {
		"fund_id": "FS00008ZY8",
		"investment_vehicle_name": "JNL Moderate Allocation A",
		"ticker": null,
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "JNL Moderate Allocation Fund",
		"fund_family_label": "Jackson National",
		"sustainable_investment": 0,
		"percent_rated": 0.4104086542405568,
		"percent_rated_long": 0.41389712599869954,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000MNDY": {
		"fund_id": "FSUSA0030D",
		"investment_vehicle_name": "JHancock Disciplined Value R6",
		"ticker": "JDVWX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "John Hancock Funds Disciplined Value Fund",
		"fund_family_label": "John Hancock",
		"sustainable_investment": 0,
		"percent_rated": 0.9679818920747923,
		"percent_rated_long": 0.9679818920747923,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FOUSA04AXL": {
		"fund_id": "FSUSA001M1",
		"investment_vehicle_name": "BlackRock Equity Dividend R",
		"ticker": "MRDVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "BlackRock Equity Dividend Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9580692208781642,
		"percent_rated_long": 0.9598276156253092,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00DTN": {
		"fund_id": "FSUSA001M1",
		"investment_vehicle_name": "BlackRock Equity Dividend Instl",
		"ticker": "MADVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "BlackRock Equity Dividend Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9580692208781642,
		"percent_rated_long": 0.9598276156253092,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA06NSW": {
		"fund_id": "FSUSA08L09",
		"investment_vehicle_name": "William Blair Emerging Mkts Ldrs R6",
		"ticker": "WELIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "William Blair Emerging Markets Leaders Fund",
		"fund_family_label": "William Blair",
		"sustainable_investment": 0,
		"percent_rated": 0.9848742836834429,
		"percent_rated_long": 0.9848742836834429,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000JXVQ": {
		"fund_id": "FSUSA000I3",
		"investment_vehicle_name": "Vanguard Emerging Mkts Stock Idx InsPlus",
		"ticker": "VEMRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Emerging Markets Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9700063913890278,
		"percent_rated_long": 0.9700621931989674,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA00P1W": {
		"fund_id": "FSUSA000I3",
		"investment_vehicle_name": "Vanguard Emerging Mkts Stock Idx Instl",
		"ticker": "VEMIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Emerging Markets Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9700063913890278,
		"percent_rated_long": 0.9700621931989674,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA05IBW": {
		"fund_id": "FSUSA000I3",
		"investment_vehicle_name": "Vanguard Emerging Mkts Stock Idx Adm",
		"ticker": "VEMAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Emerging Markets Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9700063913890278,
		"percent_rated_long": 0.9700621931989674,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA00BZK": {
		"fund_id": "FSUSA000IL",
		"investment_vehicle_name": "Fidelity Mid-Cap Stock",
		"ticker": "FMCSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Mid-Cap Stock Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9361812297263339,
		"percent_rated_long": 0.9433590263103544,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000WLTB": {
		"fund_id": "FSUSA0679C",
		"investment_vehicle_name": "Wasatch International Opps Instl",
		"ticker": "WIIOX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Wasatch International Opportunities Fund®",
		"fund_family_label": "Wasatch",
		"sustainable_investment": 0,
		"percent_rated": 0.9698600134179374,
		"percent_rated_long": 0.9698600134179374,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000OB8D": {
		"fund_id": "FSUSA067P5",
		"investment_vehicle_name": "Janus Henderson Triton N",
		"ticker": "JGMNX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Janus Henderson Triton Fund",
		"fund_family_label": "Janus Henderson",
		"sustainable_investment": 0,
		"percent_rated": 0.9868948702648899,
		"percent_rated_long": 0.9868948702648899,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00GII": {
		"fund_id": "FSUSA0031A",
		"investment_vehicle_name": "Cohen & Steers Global Realty I",
		"ticker": "CSSPX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Cohen & Steers Global Realty Shares, Inc.",
		"fund_family_label": "Cohen & Steers",
		"sustainable_investment": 0,
		"percent_rated": 0.9844976559880485,
		"percent_rated_long": 0.9844976559880485,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00DUZ": {
		"fund_id": "FSUSA000JN",
		"investment_vehicle_name": "Macquarie Small Cap Value Instl",
		"ticker": "DEVIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Macquarie Small Cap Value Fund",
		"fund_family_label": "Macquarie",
		"sustainable_investment": 0,
		"percent_rated": 0.9770578286299858,
		"percent_rated_long": 0.9770578286299858,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA00C29": {
		"fund_id": "FSUSA000JV",
		"investment_vehicle_name": "DFA US Small Cap I",
		"ticker": "DFSTX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "DFA U.S. Small Cap Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9765194698195857,
		"percent_rated_long": 0.9765194698195857,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA00C2O": {
		"fund_id": "FSUSA000K8",
		"investment_vehicle_name": "DFA US Small Cap Value I",
		"ticker": "DFSVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "DFA U.S. Small Cap Value Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9769408064201571,
		"percent_rated_long": 0.9769408064201571,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000MPYG": {
		"fund_id": "FSUSA0032Z",
		"investment_vehicle_name": "Vanguard Small Cap Value Index Admiral",
		"ticker": "VSIAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.990702364144645,
		"percent_rated_long": 0.990702364144645,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00K2U": {
		"fund_id": "FSUSA0032Z",
		"investment_vehicle_name": "Vanguard Small Cap Value Index I",
		"ticker": "VSIIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.990702364144645,
		"percent_rated_long": 0.990702364144645,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000UH3C": {
		"fund_id": "FSUSA0033M",
		"investment_vehicle_name": "Columbia Select Large Cap Value Inst3",
		"ticker": "CSRYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Columbia Select Large Cap Value Fund",
		"fund_family_label": "Columbia Threadneedle",
		"sustainable_investment": 0,
		"percent_rated": 0.9803078838175856,
		"percent_rated_long": 0.9803078838175856,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000UHR4": {
		"fund_id": "FSUSA004YC",
		"investment_vehicle_name": "Principal SmallCap Growth I R6",
		"ticker": "PCSMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Principal SmallCap Growth Fund I",
		"fund_family_label": "Principal Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9602156980062398,
		"percent_rated_long": 0.9617530447148325,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000XEEK": {
		"fund_id": "FSUSA069IM",
		"investment_vehicle_name": "JPMorgan Value Advantage R6",
		"ticker": "JVAYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan Value Advantage Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.962734385847006,
		"percent_rated_long": 0.962734385847006,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FOUSA00C3I": {
		"fund_id": "FSUSA000KP",
		"investment_vehicle_name": "Dodge & Cox Balanced I",
		"ticker": "DODBX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Dodge & Cox Balanced Fund",
		"fund_family_label": "Dodge & Cox",
		"sustainable_investment": 0,
		"percent_rated": 0.6378452077350317,
		"percent_rated_long": 0.638880290850348,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"FOUSA00C3O": {
		"fund_id": "FSUSA000KR",
		"investment_vehicle_name": "Dodge & Cox Stock I",
		"ticker": "DODGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Dodge & Cox Stock Fund",
		"fund_family_label": "Dodge & Cox",
		"sustainable_investment": 0,
		"percent_rated": 0.9859186097977038,
		"percent_rated_long": 0.9859186097977038,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00000WZOY": {
		"fund_id": "FSUSA0034J",
		"investment_vehicle_name": "T. Rowe Price Integrated US Sm Gr Eq I",
		"ticker": "TQAIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Integrated U.S. Small-Cap Growth Equity Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9661704498227784,
		"percent_rated_long": 0.9796947340674457,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000W7A4": {
		"fund_id": "FS0000C1ZI",
		"investment_vehicle_name": "Aristotle Value Equity I-2",
		"ticker": "AIQQX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Aristotle Value Equity Fund",
		"fund_family_label": "Aristotle Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9858007893071835,
		"percent_rated_long": 0.9858370286299784,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00000XRY0": {
		"fund_id": "FSUSA004YD",
		"investment_vehicle_name": "Principal Real Estate Securities Fd R6",
		"ticker": "PFRSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Principal Real Estate Securities Fund",
		"fund_family_label": "Principal Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9923557654589037,
		"percent_rated_long": 0.9923557654589037,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00GQ5": {
		"fund_id": "FSUSA001PZ",
		"investment_vehicle_name": "Vanguard Small Cap Index I",
		"ticker": "VSCIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Index",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9867676776150119,
		"percent_rated_long": 0.9867676776150119,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00L7W": {
		"fund_id": "FSUSA001PZ",
		"investment_vehicle_name": "Vanguard Small Cap Index Admiral Shares",
		"ticker": "VSMAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Index",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9867676776150119,
		"percent_rated_long": 0.9867676776150119,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000JXW4": {
		"fund_id": "FSUSA001PZ",
		"investment_vehicle_name": "Vanguard Small Cap Index InstlPlus",
		"ticker": "VSCPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Small Cap Index",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9867676776150119,
		"percent_rated_long": 0.9867676776150119,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00001DHJZ": {
		"fund_id": "FSUSA08S85",
		"investment_vehicle_name": "Dodge & Cox Global Stock X",
		"ticker": "DOXWX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Dodge & Cox Global Stock Fund",
		"fund_family_label": "Dodge & Cox",
		"sustainable_investment": 0,
		"percent_rated": 0.9562739670306285,
		"percent_rated_long": 0.9568886053509088,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"FOUSA06BXK": {
		"fund_id": "FSUSA06ALQ",
		"investment_vehicle_name": "T. Rowe Price Retirement 2045 R",
		"ticker": "RRTRX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2045 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9275468203372468,
		"percent_rated_long": 0.9324759660004164,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGK1": {
		"fund_id": "FSUSA06ALQ",
		"investment_vehicle_name": "T. Rowe Price Retirement 2045 I",
		"ticker": "TRIKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2045 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9275468203372468,
		"percent_rated_long": 0.9324759660004164,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA05C00": {
		"fund_id": "FSUSA06ALQ",
		"investment_vehicle_name": "T. Rowe Price Retirement 2045",
		"ticker": "TRRKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2045 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9275468203372468,
		"percent_rated_long": 0.9324759660004164,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA05C7A": {
		"fund_id": "FSUSA06DWE",
		"investment_vehicle_name": "AMG TimesSquare Mid Cap Growth Z",
		"ticker": "TMDIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "AMG TimesSquare Mid Cap Growth Fund",
		"fund_family_label": "AMG Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9848737613180752,
		"percent_rated_long": 0.9848737613180752,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00H6R": {
		"fund_id": "FSUSA003AE",
		"investment_vehicle_name": "DFA International Small Company I",
		"ticker": "DFISX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA International Small Company Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9693260650161426,
		"percent_rated_long": 0.9693263338100112,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000WM8M": {
		"fund_id": "FS0000C8VF",
		"investment_vehicle_name": "BlackRock LifePath® Index 2060 K",
		"ticker": "LIZKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2060 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9640031905683558,
		"percent_rated_long": 0.9718755302035181,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000TXPJ": {
		"fund_id": "FSUSA003CQ",
		"investment_vehicle_name": "Cohen & Steers Real Estate Securities Z",
		"ticker": "CSZIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Cohen & Steers Real Estate Securities Fund, Inc.",
		"fund_family_label": "Cohen & Steers",
		"sustainable_investment": 0,
		"percent_rated": 0.9901205535290917,
		"percent_rated_long": 0.9902003941275824,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00IMT": {
		"fund_id": "FSUSA003CQ",
		"investment_vehicle_name": "Cohen & Steers Real Estate Securities I",
		"ticker": "CSDIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Cohen & Steers Real Estate Securities Fund, Inc.",
		"fund_family_label": "Cohen & Steers",
		"sustainable_investment": 0,
		"percent_rated": 0.9901205535290917,
		"percent_rated_long": 0.9902003941275824,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F000002PIY": {
		"fund_id": "FSUSA001SL",
		"investment_vehicle_name": "American Funds New Perspective R6",
		"ticker": "RNPGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds New Perspective Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9712143393284021,
		"percent_rated_long": 0.9713664558572568,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FOUSA00E6B": {
		"fund_id": "FSUSA001SW",
		"investment_vehicle_name": "DFA Emerging Markets I",
		"ticker": "DFEMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA Emerging Markets Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9738740452282089,
		"percent_rated_long": 0.9738740452282089,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 3
	},
	"FOUSA06UOQ": {
		"fund_id": "FSUSA08VY3",
		"investment_vehicle_name": "Vanguard Total World Stock Index I",
		"ticker": "VTWIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total World Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9811253063744727,
		"percent_rated_long": 0.9835314469422282,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F000011IZ6": {
		"fund_id": "FSUSA08VY3",
		"investment_vehicle_name": "Vanguard Total World Stock Index Admiral",
		"ticker": "VTWAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total World Stock Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9811253063744727,
		"percent_rated_long": 0.9835314469422282,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000X3MB": {
		"fund_id": "FSUSA06FFY",
		"investment_vehicle_name": "Federated Hermes MDT Small Cap Core R6",
		"ticker": "QLSCX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Federated Hermes MDT Small Cap Core Fund",
		"fund_family_label": "Federated",
		"sustainable_investment": 0,
		"percent_rated": 0.9804282085737752,
		"percent_rated_long": 0.9804282085737752,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 3
	},
	"FOUSA00CBJ": {
		"fund_id": "FSUSA000PI",
		"investment_vehicle_name": "American Funds Europacific Growth A",
		"ticker": "AEPGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds EuroPacific Growth Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9377614792879904,
		"percent_rated_long": 0.9403179434234604,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA02UZS": {
		"fund_id": "FSUSA000PI",
		"investment_vehicle_name": "American Funds Europacific Growth R5",
		"ticker": "RERFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds EuroPacific Growth Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9377614792879904,
		"percent_rated_long": 0.9403179434234604,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F000002P1T": {
		"fund_id": "FSUSA000PI",
		"investment_vehicle_name": "American Funds Europacific Growth R6",
		"ticker": "RERGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds EuroPacific Growth Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9377614792879904,
		"percent_rated_long": 0.9403179434234604,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA02TY5": {
		"fund_id": "FSUSA000PQ",
		"investment_vehicle_name": "Vanguard Explorer Adm",
		"ticker": "VEXRX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Explorer Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.970609561896525,
		"percent_rated_long": 0.9738828689770084,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 3
	},
	"FOUSA00HD4": {
		"fund_id": "FSUSA003CZ",
		"investment_vehicle_name": "UBS US Small Cap Growth P",
		"ticker": "BISCX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "UBS U.S. Small Cap Growth Fund",
		"fund_family_label": "UBS",
		"sustainable_investment": 0,
		"percent_rated": 0.9811521602924368,
		"percent_rated_long": 0.9811521602924368,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02SV3": {
		"fund_id": "FSUSA008V6",
		"investment_vehicle_name": "BlackRock Health Sciences Opps Instl",
		"ticker": "SHSSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "BlackRock Health Sciences Opportunities Portfolio",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9761398049304676,
		"percent_rated_long": 0.976706034040704,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000MJRH": {
		"fund_id": "FSUSA003EG",
		"investment_vehicle_name": "Fidelity Extended Market Index",
		"ticker": "FSMAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Extended Market Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9959704563035595,
		"percent_rated_long": 0.9966077346141915,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00E9G": {
		"fund_id": "FSUSA001UU",
		"investment_vehicle_name": "Oakmark International Investor",
		"ticker": "OAKIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Oakmark International Fund",
		"fund_family_label": "Oakmark",
		"sustainable_investment": 0,
		"percent_rated": 0.9652913951039099,
		"percent_rated_long": 0.9652913951039099,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 5,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000XOSV": {
		"fund_id": "FSUSA001UU",
		"investment_vehicle_name": "Oakmark International Institutional",
		"ticker": "OANIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Oakmark International Fund",
		"fund_family_label": "Oakmark",
		"sustainable_investment": 0,
		"percent_rated": 0.9652913951039099,
		"percent_rated_long": 0.9652913951039099,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 5,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA05CLF": {
		"fund_id": "FSUSA06GLH",
		"investment_vehicle_name": "DFA Emerging Markets Core Equity I",
		"ticker": "DFCEX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA Emerging Markets Core Equity Fund",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9880486996617276,
		"percent_rated_long": 0.988052108684012,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 3
	},
	"F00000NDAR": {
		"fund_id": "FSUSA001V8",
		"investment_vehicle_name": "Invesco Global R6",
		"ticker": "OGLIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Invesco Global Fund",
		"fund_family_label": "Invesco",
		"sustainable_investment": 0,
		"percent_rated": 0.9891453779731794,
		"percent_rated_long": 0.9928566029357159,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000WZVI": {
		"fund_id": "FS0000CFDS",
		"investment_vehicle_name": "Fidelity Large Cap Value Index",
		"ticker": "FLCOX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Large Cap Value Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9933089569268527,
		"percent_rated_long": 0.9949155963295852,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000WZVM": {
		"fund_id": "FS0000CFDT",
		"investment_vehicle_name": "Fidelity Total International Index",
		"ticker": "FTIHX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Total International Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9370064344236769,
		"percent_rated_long": 0.9560037672594677,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000WZW5": {
		"fund_id": "FS0000CFE4",
		"investment_vehicle_name": "Fidelity Large Cap Growth Idx",
		"ticker": "FSPGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Large Cap Growth Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.993961945942119,
		"percent_rated_long": 0.9958427293581049,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA06TXQ": {
		"fund_id": "FSUSA000RN",
		"investment_vehicle_name": "Fidelity Balanced K",
		"ticker": "FBAKX",
		"portfolio_date": "2024-09-30",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Balanced Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.5915114827168898,
		"percent_rated_long": 0.6126366446103038,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06U11": {
		"fund_id": "FSUSA000RO",
		"investment_vehicle_name": "Fidelity Capital Appreciation K",
		"ticker": "FCAKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Capital Appreciation Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9862276485315993,
		"percent_rated_long": 0.9862276485315993,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA06TX6": {
		"fund_id": "FSUSA000RQ",
		"investment_vehicle_name": "Fidelity Contrafund K",
		"ticker": "FCNKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Contrafund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9466403934810427,
		"percent_rated_long": 0.9467688550124633,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA00CEO": {
		"fund_id": "FSUSA000RQ",
		"investment_vehicle_name": "Fidelity Contrafund",
		"ticker": "FCNTX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Contrafund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9466403934810427,
		"percent_rated_long": 0.9467688550124633,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA06TXK": {
		"fund_id": "FSUSA000S4",
		"investment_vehicle_name": "Fidelity Diversified International K",
		"ticker": "FDIKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Diversified International Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9730240655379483,
		"percent_rated_long": 0.9733350906902873,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA00CF9": {
		"fund_id": "FSUSA000S4",
		"investment_vehicle_name": "Fidelity Diversified International",
		"ticker": "FDIVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Diversified International Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9730240655379483,
		"percent_rated_long": 0.9733350906902873,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA06TXR": {
		"fund_id": "FSUSA000S6",
		"investment_vehicle_name": "Fidelity Low-Priced Stock K",
		"ticker": "FLPKX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Low-Priced Stock Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9826967186174261,
		"percent_rated_long": 0.9830407428293106,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00CFE": {
		"fund_id": "FSUSA000S6",
		"investment_vehicle_name": "Fidelity Low-Priced Stock",
		"ticker": "FLPSX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Low-Priced Stock Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9826967186174261,
		"percent_rated_long": 0.9830407428293106,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00001DBZ9": {
		"fund_id": "FS0000HDIC",
		"investment_vehicle_name": "Vanguard Target Retirement 2070 Fund",
		"ticker": "VSVNX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2070 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8487579684079436,
		"percent_rated_long": 0.8663658264101077,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000MTCG": {
		"fund_id": "FSUSA003H1",
		"investment_vehicle_name": "JHancock Disciplined Value Mid Cap R6",
		"ticker": "JVMRX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "John Hancock Funds Disciplined Value Mid Cap Fund",
		"fund_family_label": "John Hancock",
		"sustainable_investment": 0,
		"percent_rated": 0.9727596548538892,
		"percent_rated_long": 0.9727673368539801,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00HOD": {
		"fund_id": "FSUSA003H8",
		"investment_vehicle_name": "Vanguard Mid Cap Growth Inv",
		"ticker": "VMGRX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid-Cap Growth",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9684712655989449,
		"percent_rated_long": 0.9684712655989449,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000NB29": {
		"fund_id": "FSUSA003HS",
		"investment_vehicle_name": "Invesco Developing Markets R6",
		"ticker": "ODVIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Invesco Developing Markets Fund",
		"fund_family_label": "Invesco",
		"sustainable_investment": 0,
		"percent_rated": 0.9603874354239896,
		"percent_rated_long": 0.961618944592893,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F000011GCX": {
		"fund_id": "FSUSA003HS",
		"investment_vehicle_name": "Invesco Developing Markets R5",
		"ticker": "DVMFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Invesco Developing Markets Fund",
		"fund_family_label": "Invesco",
		"sustainable_investment": 0,
		"percent_rated": 0.9603874354239896,
		"percent_rated_long": 0.961618944592893,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000VWN0": {
		"fund_id": "FSUSA001WI",
		"investment_vehicle_name": "T. Rowe Price Small-Cap Stock I",
		"ticker": "OTIIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Small-Cap Stock Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9324832754369223,
		"percent_rated_long": 0.9324832754369223,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA02TGA": {
		"fund_id": "FSUSA0096D",
		"investment_vehicle_name": "Dodge & Cox International Stock I",
		"ticker": "DODFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Dodge & Cox International Stock Fund",
		"fund_family_label": "Dodge & Cox",
		"sustainable_investment": 0,
		"percent_rated": 0.951573839107903,
		"percent_rated_long": 0.9523309059144217,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 5
	},
	"F00001DHK0": {
		"fund_id": "FSUSA0096D",
		"investment_vehicle_name": "Dodge & Cox International Stock X",
		"ticker": "DOXFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Dodge & Cox International Stock Fund",
		"fund_family_label": "Dodge & Cox",
		"sustainable_investment": 0,
		"percent_rated": 0.951573839107903,
		"percent_rated_long": 0.9523309059144217,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 5
	},
	"FOUSA05BKA": {
		"fund_id": "FSUSA0096H",
		"investment_vehicle_name": "AB Discovery Value I",
		"ticker": "ABSIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "AB Discovery Value Fund",
		"fund_family_label": "AllianceBernstein",
		"sustainable_investment": 0,
		"percent_rated": 0.990340582341868,
		"percent_rated_long": 0.990340582341868,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA06TXM": {
		"fund_id": "FSUSA000T0",
		"investment_vehicle_name": "Fidelity Emerging Markets K",
		"ticker": "FKEMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Emerging Markets Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9783438519964486,
		"percent_rated_long": 0.9810038058454209,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA06U0Z": {
		"fund_id": "FSUSA000TD",
		"investment_vehicle_name": "Fidelity Growth Company K",
		"ticker": "FGCKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Growth Company Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9569078940204403,
		"percent_rated_long": 0.9571925909466067,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 4
	},
	"FOUSA00CH5": {
		"fund_id": "FSUSA000TD",
		"investment_vehicle_name": "Fidelity Growth Company Fund",
		"ticker": "FDGRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Growth Company Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9569078940204403,
		"percent_rated_long": 0.9571925909466067,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 4
	},
	"F00000MJS0": {
		"fund_id": "FSUSA003JP",
		"investment_vehicle_name": "Fidelity Total Market Index",
		"ticker": "FSKAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Total Market Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9991187637633335,
		"percent_rated_long": 0.9991187637633335,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000MSXN": {
		"fund_id": "FSUSA001YY",
		"investment_vehicle_name": "JPMorgan US Small Company R6",
		"ticker": "JUSMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan U.S. Small Company Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9673744293817633,
		"percent_rated_long": 0.9673744293817633,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00000JSDA": {
		"fund_id": "FSUSA001YZ",
		"investment_vehicle_name": "JPMorgan US Equity R6",
		"ticker": "JUEMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan U.S. Equity Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9936496195453879,
		"percent_rated_long": 0.9936496195453879,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000N6WY": {
		"fund_id": "FSUSA06IUX",
		"investment_vehicle_name": "Diamond Hill Small-Mid Cap Y",
		"ticker": "DHMYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Diamond Hill Small-Mid Cap Fund",
		"fund_family_label": "Diamond Hill Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9619733130787366,
		"percent_rated_long": 0.9619733130787366,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA00CHX": {
		"fund_id": "FSUSA000TV",
		"investment_vehicle_name": "Fidelity Real Estate Investment Port",
		"ticker": "FRESX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity Real Estate Investment Portfolio",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9914417029618567,
		"percent_rated_long": 0.9914417029618567,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00CHY": {
		"fund_id": "FSUSA000TW",
		"investment_vehicle_name": "Fidelity Overseas",
		"ticker": "FOSFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Overseas Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9835266438763014,
		"percent_rated_long": 0.9843275528419991,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA00CI3": {
		"fund_id": "FSUSA000U1",
		"investment_vehicle_name": "Fidelity Puritan",
		"ticker": "FPURX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Puritan Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.6312354094235301,
		"percent_rated_long": 0.6421504102891142,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06TY5": {
		"fund_id": "FSUSA000UB",
		"investment_vehicle_name": "Fidelity OTC K",
		"ticker": "FOCKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity OTC Portfolio",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9679734797284094,
		"percent_rated_long": 0.968449788577451,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00CID": {
		"fund_id": "FSUSA000UB",
		"investment_vehicle_name": "Fidelity OTC",
		"ticker": "FOCPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity OTC Portfolio",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9679734797284094,
		"percent_rated_long": 0.968449788577451,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00CIK": {
		"fund_id": "FSUSA000UI",
		"investment_vehicle_name": "Fidelity Select Energy Portfolio",
		"ticker": "FSENX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity Select Energy Portfolio",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9974671347555082,
		"percent_rated_long": 0.9974671347555082,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00CJE": {
		"fund_id": "FSUSA000V5",
		"investment_vehicle_name": "Fidelity Select Technology",
		"ticker": "FSPTX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity Select Technology Portfolio",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9711468215912423,
		"percent_rated_long": 0.971439645275412,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000PJJE": {
		"fund_id": "FSUSA003MN",
		"investment_vehicle_name": "Undiscovered Managers Behavioral Val R6",
		"ticker": "UBVFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Undiscovered Managers Behavioral Value Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9958090252788205,
		"percent_rated_long": 0.9958090252788205,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00EI7": {
		"fund_id": "FSUSA0020C",
		"investment_vehicle_name": "T. Rowe Price Blue Chip Growth",
		"ticker": "TRBCX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Blue Chip Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9768100710715272,
		"percent_rated_long": 0.9797247335110008,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000WMWX": {
		"fund_id": "FSUSA0020C",
		"investment_vehicle_name": "T. Rowe Price Blue Chip Growth I",
		"ticker": "TBCIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Blue Chip Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9768100710715272,
		"percent_rated_long": 0.9797247335110008,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02VN6": {
		"fund_id": "FSUSA0020C",
		"investment_vehicle_name": "T. Rowe Price Blue Chip Growth R",
		"ticker": "RRBGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Blue Chip Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9768100710715272,
		"percent_rated_long": 0.9797247335110008,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000QHZ6": {
		"fund_id": "FSUSA00DPZ",
		"investment_vehicle_name": "JPMorgan Emerging Markets Equity R6",
		"ticker": "JEMWX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "JPMorgan Emerging Markets Equity Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9942592854359329,
		"percent_rated_long": 0.9942592854359329,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 4
	},
	"F00000LZSI": {
		"fund_id": "FSUSA000VE",
		"investment_vehicle_name": "Fidelity 500 Index",
		"ticker": "FXAIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity 500 Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9989312923832213,
		"percent_rated_long": 0.9989312923832213,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FOUSA08MX0": {
		"fund_id": "FSUSA000VH",
		"investment_vehicle_name": "Fidelity Advisor Worldwide I",
		"ticker": "FWIFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Worldwide Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9667190833967793,
		"percent_rated_long": 0.9667190833967793,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 5
	},
	"FOUSA00CLE": {
		"fund_id": "FSUSA000W2",
		"investment_vehicle_name": "Northern Small Cap Value",
		"ticker": "NOSGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Northern Small Cap Value Fund",
		"fund_family_label": "Northern Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9624475240537885,
		"percent_rated_long": 0.9624475240537885,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00EIV": {
		"fund_id": "FSUSA0020Z",
		"investment_vehicle_name": "T. Rowe Price Equity Income",
		"ticker": "PRFDX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Equity Income Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9862743987014153,
		"percent_rated_long": 0.9862743987014153,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 5,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F00000VWMV": {
		"fund_id": "FSUSA00216",
		"investment_vehicle_name": "T. Rowe Price Mid-Cap Growth I",
		"ticker": "RPTIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Mid-Cap Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9620484491106495,
		"percent_rated_long": 0.9620484491106495,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000VWMT": {
		"fund_id": "FSUSA00219",
		"investment_vehicle_name": "T. Rowe Price Growth Stock I",
		"ticker": "PRUFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Growth Stock Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9611163928630426,
		"percent_rated_long": 0.9611163928630426,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F000014VHI": {
		"fund_id": "FSUSA00219",
		"investment_vehicle_name": "T. Rowe Price Growth Stock Z",
		"ticker": "TRJZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Growth Stock Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9611163928630426,
		"percent_rated_long": 0.9611163928630426,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000PGEH": {
		"fund_id": "FSUSA00DUD",
		"investment_vehicle_name": "MFS Mid Cap Value R6",
		"ticker": "MVCKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MFS Mid Cap Value Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9708540772170774,
		"percent_rated_long": 0.9708540772170774,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00EJD": {
		"fund_id": "FSUSA0021E",
		"investment_vehicle_name": "T. Rowe Price International Stock",
		"ticker": "PRITX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "T. Rowe Price International Stock Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9733732762771089,
		"percent_rated_long": 0.9734527102369225,
		"grade_fossil": 4,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00EJR": {
		"fund_id": "FSUSA0021L",
		"investment_vehicle_name": "T. Rowe Price New Horizons",
		"ticker": "PRNHX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price New Horizons Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.932944497533516,
		"percent_rated_long": 0.932944497533516,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00EKD": {
		"fund_id": "FSUSA0021V",
		"investment_vehicle_name": "T. Rowe Price Science & Tech",
		"ticker": "PRSCX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "T. Rowe Price Science And Technology Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9739247963747625,
		"percent_rated_long": 0.9775635686309321,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00EKG": {
		"fund_id": "FSUSA0021Y",
		"investment_vehicle_name": "T. Rowe Price Small-Cap Value",
		"ticker": "PRSVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Small-Cap Value Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9528556912183516,
		"percent_rated_long": 0.9528556912183516,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000VQAD": {
		"fund_id": "FSUSA0A7L9",
		"investment_vehicle_name": "Fidelity Freedom Index 2035 Instl Prem",
		"ticker": "FFEZX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2035 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.6127158322142179,
		"percent_rated_long": 0.6383894215986228,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F0000154M4": {
		"fund_id": "FSUSA0A7L9",
		"investment_vehicle_name": "Fidelity Freedom Index 2035 Premier",
		"ticker": "FNIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2035 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.6127158322142179,
		"percent_rated_long": 0.6383894215986228,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000VQAC": {
		"fund_id": "FSUSA0A7LB",
		"investment_vehicle_name": "Fidelity Freedom Index 2030 Instl Prem",
		"ticker": "FFEGX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2030 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.5203743608792464,
		"percent_rated_long": 0.5446720174499277,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F0000154M3": {
		"fund_id": "FSUSA0A7LB",
		"investment_vehicle_name": "Fidelity Freedom Index 2030 Premier",
		"ticker": "FMKPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2030 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.5203743608792464,
		"percent_rated_long": 0.5446720174499277,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000VQAE": {
		"fund_id": "FSUSA0A7LC",
		"investment_vehicle_name": "Fidelity Freedom Index 2040 Instl Prem",
		"ticker": "FFIZX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2040 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.7765946465865555,
		"percent_rated_long": 0.7940253043328086,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F0000154M5": {
		"fund_id": "FSUSA0A7LC",
		"investment_vehicle_name": "Fidelity Freedom Index 2040 Premier",
		"ticker": "FPIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2040 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.7765946465865555,
		"percent_rated_long": 0.7940253043328086,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F0000154LV": {
		"fund_id": "FSUSA0A7LD",
		"investment_vehicle_name": "Fidelity Freedom Index 2045 Premier",
		"ticker": "FQIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2045 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690948954473012,
		"percent_rated_long": 0.8776330474400322,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000VQAF": {
		"fund_id": "FSUSA0A7LD",
		"investment_vehicle_name": "Fidelity Freedom Index 2045 Instl Prem",
		"ticker": "FFOLX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2045 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690948954473012,
		"percent_rated_long": 0.8776330474400322,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000VQA8": {
		"fund_id": "FSUSA0A7LE",
		"investment_vehicle_name": "Fidelity Freedom Index 2010 Instl Prem",
		"ticker": "FFWTX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2010 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.22429557390010071,
		"percent_rated_long": 0.23484641205478116,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000VQA9": {
		"fund_id": "FSUSA0A7LJ",
		"investment_vehicle_name": "Fidelity Freedom Index 2015 Instl Prem",
		"ticker": "FIWFX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2015 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.3055171854614145,
		"percent_rated_long": 0.3199349281560134,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F0000154M0": {
		"fund_id": "FSUSA0A7LJ",
		"investment_vehicle_name": "Fidelity Freedom Index 2015 Premier",
		"ticker": "FFYPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2015 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.3055171854614145,
		"percent_rated_long": 0.3199349281560134,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000VQAB": {
		"fund_id": "FSUSA0A7LN",
		"investment_vehicle_name": "Fidelity Freedom Index 2025 Instl Prem",
		"ticker": "FFEDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2025 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.4609109962125928,
		"percent_rated_long": 0.4825011174036203,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F0000154M2": {
		"fund_id": "FSUSA0A7LN",
		"investment_vehicle_name": "Fidelity Freedom Index 2025 Premier",
		"ticker": "FLIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2025 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.4609109962125928,
		"percent_rated_long": 0.4825011174036203,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000VQAH": {
		"fund_id": "FSUSA0A7LO",
		"investment_vehicle_name": "Fidelity Freedom Index Inc Instl Prem",
		"ticker": "FFGZX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index Income Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.16765286754962105,
		"percent_rated_long": 0.17555028422581073,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F0000154LX": {
		"fund_id": "FSUSA0A7LO",
		"investment_vehicle_name": "Fidelity Freedom Index Income Premier",
		"ticker": "FAPIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index Income Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.16765286754962105,
		"percent_rated_long": 0.17555028422581073,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000VQAA": {
		"fund_id": "FSUSA0A7LQ",
		"investment_vehicle_name": "Fidelity Freedom Index 2020 Instl Prem",
		"ticker": "FIWTX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2020 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.38702167407084065,
		"percent_rated_long": 0.4053575009694877,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F0000154M1": {
		"fund_id": "FSUSA0A7LQ",
		"investment_vehicle_name": "Fidelity Freedom Index 2020 Premier",
		"ticker": "FKIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2020 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.38702167407084065,
		"percent_rated_long": 0.4053575009694877,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA05H97": {
		"fund_id": "FSUSA06U45",
		"investment_vehicle_name": "Nuveen Large Cap Growth R6",
		"ticker": "TILGX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Large Cap Growth Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9928708926377869,
		"percent_rated_long": 0.9928708926377869,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000PA0N": {
		"fund_id": "FS00009WWM",
		"investment_vehicle_name": "DFA World ex US Core Equity Instl",
		"ticker": "DFWIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA World ex U.S. Core Equity Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9699680924500175,
		"percent_rated_long": 0.9699680924500175,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000WLFX": {
		"fund_id": "FS00009X6B",
		"investment_vehicle_name": "BlackRock Advantage Small Cap Core K",
		"ticker": "BDSKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "BlackRock Advantage Small Cap Core Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9658007967896741,
		"percent_rated_long": 0.976345565165529,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000YBQB": {
		"fund_id": "FS0000D06W",
		"investment_vehicle_name": "Natixis Target Retirement 2015 N",
		"ticker": "NSFBX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Natixis Target Retiremet 2015",
		"fund_family_label": "Natixis Funds",
		"sustainable_investment": 1,
		"percent_rated": 0.3482169781547556,
		"percent_rated_long": 0.34891443156720414,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000YBQF": {
		"fund_id": "FS0000D06Y",
		"investment_vehicle_name": "Natixis Target Retirement 2020 N",
		"ticker": "NSFDX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Natixis Target Retiremet 2020",
		"fund_family_label": "Natixis Funds",
		"sustainable_investment": 1,
		"percent_rated": 0.4151541707566431,
		"percent_rated_long": 0.41613522183380247,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000YBQH": {
		"fund_id": "FS0000D06Z",
		"investment_vehicle_name": "Natixis Target Retirement 2025 N",
		"ticker": "NSFEX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Natixis Target Retiremet 2025",
		"fund_family_label": "Natixis Funds",
		"sustainable_investment": 1,
		"percent_rated": 0.4935455926092395,
		"percent_rated_long": 0.49449476764144257,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000YE51": {
		"fund_id": "FS0000D17J",
		"investment_vehicle_name": "Vanguard Target Retirement 2065 Fund",
		"ticker": "VLXVX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2065 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8470317100627538,
		"percent_rated_long": 0.8651873292378766,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F0000045YA": {
		"fund_id": "FSUSA0A8YJ",
		"investment_vehicle_name": "American Funds 2055 Trgt Date Retire R6",
		"ticker": "RFKTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2055 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.8782689427111313,
		"percent_rated_long": 0.8801880817736466,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"FOUSA00ID5": {
		"fund_id": "FSUSA003PY",
		"investment_vehicle_name": "JPMorgan Mid Cap Value L",
		"ticker": "FLMVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan Mid Cap Value Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9734838648951537,
		"percent_rated_long": 0.9734838648951537,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA02TYC": {
		"fund_id": "FSUSA003Q9",
		"investment_vehicle_name": "Vanguard Mid Cap Index Admiral",
		"ticker": "VIMAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid Cap Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9970863479252632,
		"percent_rated_long": 0.9972308017224436,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000JXVT": {
		"fund_id": "FSUSA003Q9",
		"investment_vehicle_name": "Vanguard Mid Cap Index InstitutionalPlus",
		"ticker": "VMCPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid Cap Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9970863479252632,
		"percent_rated_long": 0.9972308017224436,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00J83": {
		"fund_id": "FSUSA003Q9",
		"investment_vehicle_name": "Vanguard Mid Cap Index Institutional",
		"ticker": "VMCIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Mid Cap Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9970863479252632,
		"percent_rated_long": 0.9972308017224436,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000JSAQ": {
		"fund_id": "FSUSA0023I",
		"investment_vehicle_name": "PGIM Jennison Small Company R6",
		"ticker": "PJSQX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "PGIM Jennison Small Company Fund",
		"fund_family_label": "PGIM Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9817254970540448,
		"percent_rated_long": 0.9817254970540448,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000YI8J": {
		"fund_id": "FS0000D2Y3",
		"investment_vehicle_name": "Fidelity Blue Chip Growth K6",
		"ticker": "FBCGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Blue Chip Growth K6 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.94986410569239,
		"percent_rated_long": 0.9567125760111407,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000YI8K": {
		"fund_id": "FS0000D2Y4",
		"investment_vehicle_name": "Fidelity Small Cap Growth K6",
		"ticker": "FOCSX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Small Cap Growth K6 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9113800308354855,
		"percent_rated_long": 0.9120571292931118,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000YI8R": {
		"fund_id": "FS0000D2Y7",
		"investment_vehicle_name": "Fidelity Contrafund K6",
		"ticker": "FLCNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Contrafund K6",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.962522421782103,
		"percent_rated_long": 0.9625419254751785,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"F00000YK7W": {
		"fund_id": "FS0000D3Q2",
		"investment_vehicle_name": "Fidelity Diversified Intl K6",
		"ticker": "FKIDX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Diversified International K6 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9760297203531044,
		"percent_rated_long": 0.976316968509658,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000YK7Z": {
		"fund_id": "FS0000D3Q5",
		"investment_vehicle_name": "Fidelity Low-Priced Stock K6",
		"ticker": "FLKSX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Low-Priced Stock K6 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9478322482024965,
		"percent_rated_long": 0.9481142448563755,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA05BEU": {
		"fund_id": "FSUSA00ESY",
		"investment_vehicle_name": "Diamond Hill Large Cap I",
		"ticker": "DHLRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Diamond Hill Large Cap Fund",
		"fund_family_label": "Diamond Hill Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9745439824824157,
		"percent_rated_long": 0.9745439824824157,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000N6WT": {
		"fund_id": "FSUSA00ESY",
		"investment_vehicle_name": "Diamond Hill Large Cap Y",
		"ticker": "DHLYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Diamond Hill Large Cap Fund",
		"fund_family_label": "Diamond Hill Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9745439824824157,
		"percent_rated_long": 0.9745439824824157,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA05BT9": {
		"fund_id": "FSUSA003SQ",
		"investment_vehicle_name": "MFS Value R3",
		"ticker": "MEIHX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MFS Value Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9868483683151301,
		"percent_rated_long": 0.9868483683151301,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA05HQN": {
		"fund_id": "FSUSA003SQ",
		"investment_vehicle_name": "MFS Value R6",
		"ticker": "MEIKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MFS Value Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9868483683151301,
		"percent_rated_long": 0.9868483683151301,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA00CSM": {
		"fund_id": "FSUSA0010U",
		"investment_vehicle_name": "Vanguard Global Equity Inv",
		"ticker": "VHGEX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Global Equity Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9542320018654238,
		"percent_rated_long": 0.957042504359701,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000OLLC": {
		"fund_id": "FSUSA00251",
		"investment_vehicle_name": "Putnam Large Cap Value R6",
		"ticker": "PEQSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Putnam Large Cap Value Fund",
		"fund_family_label": "Franklin Templeton Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9277239492013629,
		"percent_rated_long": 0.9388252216683198,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F000005OKQ": {
		"fund_id": "FSUSA0ALQQ",
		"investment_vehicle_name": "Vanguard Explorer Value Inv",
		"ticker": "VEVFX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Explorer Value Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9258700393354181,
		"percent_rated_long": 0.9274383388067563,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"FOUSA00J8E": {
		"fund_id": "FSUSA0011N",
		"investment_vehicle_name": "Franklin Utilities Adv",
		"ticker": "FRUAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Franklin Utilities Fund",
		"fund_family_label": "Franklin Templeton Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9942845319662057,
		"percent_rated_long": 0.9942845319662057,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00ESV": {
		"fund_id": "FSUSA0026W",
		"investment_vehicle_name": "Davis Financial A",
		"ticker": "RPFGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Davis Financial Fund",
		"fund_family_label": "Davis",
		"sustainable_investment": 0,
		"percent_rated": 0.9837625769959211,
		"percent_rated_long": 0.9837625769959211,
		"grade_fossil": 3,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000VWMW": {
		"fund_id": "FSUSA003WX",
		"investment_vehicle_name": "T. Rowe Price Mid-Cap Value I",
		"ticker": "TRMIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Mid-Cap Value Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9305102041586729,
		"percent_rated_long": 0.9305102041586729,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA05HAH": {
		"fund_id": "FSUSA00H60",
		"investment_vehicle_name": "Nuveen Core Equity A",
		"ticker": "TIIRX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Core Equity Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9921182709989942,
		"percent_rated_long": 0.9921182709989942,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02VH5": {
		"fund_id": "FSUSA00H63",
		"investment_vehicle_name": "Nuveen International Eq R6",
		"ticker": "TIIEX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Nuveen International Equity Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9522768570326212,
		"percent_rated_long": 0.9522768570326212,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"FOUSA02VIY": {
		"fund_id": "FSUSA00HBD",
		"investment_vehicle_name": "T. Rowe Price Lrg Cp Gr I",
		"ticker": "TRLGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Large-Cap Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9578741929130301,
		"percent_rated_long": 0.9578741929130301,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000QT2H": {
		"fund_id": "FSUSA072AM",
		"investment_vehicle_name": "State Street Aggregate Bond Index I",
		"ticker": "SSFDX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Taxable Bond Funds",
		"fund_legal_name": "State Street Aggregate Bond Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0,
		"percent_rated_long": 0,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000QT2G": {
		"fund_id": "FSUSA072AM",
		"investment_vehicle_name": "State Street Aggregate Bond Index K",
		"ticker": "SSFEX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Taxable Bond Funds",
		"fund_legal_name": "State Street Aggregate Bond Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0,
		"percent_rated_long": 0,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA05HZD": {
		"fund_id": "FSUSA072BG",
		"investment_vehicle_name": "Vanguard Target Retirement 2020 Fund",
		"ticker": "VTWNX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2020 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.2968125364364768,
		"percent_rated_long": 0.3244389460421864,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA05HZE": {
		"fund_id": "FSUSA072BH",
		"investment_vehicle_name": "Vanguard Target Retirement 2030 Fund",
		"ticker": "VTHRX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2030 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.5106571494233543,
		"percent_rated_long": 0.5492438824209022,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA05HZF": {
		"fund_id": "FSUSA072BI",
		"investment_vehicle_name": "Vanguard Target Retirement 2040 Fund",
		"ticker": "VFORX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2040 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.6713560336960044,
		"percent_rated_long": 0.7038121733539658,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00CXH": {
		"fund_id": "FSUSA0013U",
		"investment_vehicle_name": "Lazard Emerging Markets Equity Instl",
		"ticker": "LZEMX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Lazard Emerging Markets Equity Portfolio",
		"fund_family_label": "Lazard",
		"sustainable_investment": 0,
		"percent_rated": 0.9860192048120697,
		"percent_rated_long": 0.9860192048120697,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 4
	},
	"FOUSA06J7M": {
		"fund_id": "FSUSA0014N",
		"investment_vehicle_name": "Victory Sycamore Small Company Opp I",
		"ticker": "VSOIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Sycamore Small Company Opportunity Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9685900551614254,
		"percent_rated_long": 0.9685900551614254,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000WHXG": {
		"fund_id": "FSUSA0014N",
		"investment_vehicle_name": "Victory Sycamore Small Company Opp R6",
		"ticker": "VSORX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Sycamore Small Company Opportunity Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9685900551614254,
		"percent_rated_long": 0.9685900551614254,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000Q5TH": {
		"fund_id": "FS0000A920",
		"investment_vehicle_name": "Baron Discovery Institutional",
		"ticker": "BDFIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Baron Discovery Fund",
		"fund_family_label": "Baron Capital Group, Inc.",
		"sustainable_investment": 0,
		"percent_rated": 0.9610558536886039,
		"percent_rated_long": 0.9610558536886039,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA02VMM": {
		"fund_id": "FSUSA00IJY",
		"investment_vehicle_name": "DFA US Targeted Value I",
		"ticker": "DFFVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "DFA U.S. Targeted Value Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9710152384383645,
		"percent_rated_long": 0.9710152384383645,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06J7K": {
		"fund_id": "FSUSA0014P",
		"investment_vehicle_name": "Victory Sycamore Established Value I",
		"ticker": "VEVIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Sycamore Established Value Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9724843305923441,
		"percent_rated_long": 0.9724843305923441,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA00JW9": {
		"fund_id": "FSUSA0014P",
		"investment_vehicle_name": "Victory Sycamore Established Value A",
		"ticker": "VETAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Sycamore Established Value Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9724843305923441,
		"percent_rated_long": 0.9724843305923441,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000SCG4": {
		"fund_id": "FSUSA0014P",
		"investment_vehicle_name": "Victory Sycamore Established Value R6",
		"ticker": "VEVRX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Sycamore Established Value Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9724843305923441,
		"percent_rated_long": 0.9724843305923441,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F000002PJ1": {
		"fund_id": "FSUSA00155",
		"investment_vehicle_name": "American Funds Growth Fund of Amer R6",
		"ticker": "RGAGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Funds The Growth Fund of America®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.976887916822956,
		"percent_rated_long": 0.9772225808962903,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"F00000VYY8": {
		"fund_id": "FSUSA00159",
		"investment_vehicle_name": "Goldman Sachs Small Cap Value R6",
		"ticker": "GSSUX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Goldman Sachs Small Cap Value Fund",
		"fund_family_label": "Goldman Sachs",
		"sustainable_investment": 0,
		"percent_rated": 0.9799216199663099,
		"percent_rated_long": 0.9799216199663099,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA00IHW": {
		"fund_id": "FSUSA00159",
		"investment_vehicle_name": "Goldman Sachs Small Cap Value Inst",
		"ticker": "GSSIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Goldman Sachs Small Cap Value Fund",
		"fund_family_label": "Goldman Sachs",
		"sustainable_investment": 0,
		"percent_rated": 0.9799216199663099,
		"percent_rated_long": 0.9799216199663099,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000JSAV": {
		"fund_id": "FSUSA003ZZ",
		"investment_vehicle_name": "JPMorgan International Equity R6",
		"ticker": "JNEMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "JPMorgan International Equity Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.973302897385128,
		"percent_rated_long": 0.973302897385128,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 5,
		"grade_deforestation": 5,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00B1V": {
		"fund_id": "FSUSA0000K",
		"investment_vehicle_name": "DFA International Small Cap Value I",
		"ticker": "DISVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "DFA International Small Cap Value Portfolio",
		"fund_family_label": "Dimensional Fund Advisors",
		"sustainable_investment": 0,
		"percent_rated": 0.9880426196459469,
		"percent_rated_long": 0.9880426196459469,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA02VN9": {
		"fund_id": "FSUSA00IKR",
		"investment_vehicle_name": "T. Rowe Price Retirement Balanced",
		"ticker": "TRRIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement Balanced Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.38471938271701733,
		"percent_rated_long": 0.38833227334925374,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BH5": {
		"fund_id": "FSUSA00IKR",
		"investment_vehicle_name": "T. Rowe Price Retirement Balanced R",
		"ticker": "RRTIX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement Balanced Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.38471938271701733,
		"percent_rated_long": 0.38833227334925374,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA02VNA": {
		"fund_id": "FSUSA00IKS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2010",
		"ticker": "TRRAX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2010 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.4338825177601779,
		"percent_rated_long": 0.4383563671172276,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00001GGK9": {
		"fund_id": "FSUSA00IKS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2010 I",
		"ticker": "TRPUX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2010 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.4338825177601779,
		"percent_rated_long": 0.4383563671172276,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BEX": {
		"fund_id": "FSUSA00IKS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2010 R",
		"ticker": "RRTAX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2010 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.4338825177601779,
		"percent_rated_long": 0.4383563671172276,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00001GGK8": {
		"fund_id": "FSUSA00IKT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2020 I",
		"ticker": "TRDBX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2020 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.48756944468698105,
		"percent_rated_long": 0.497705420154904,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA02VNB": {
		"fund_id": "FSUSA00IKT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2020",
		"ticker": "TRRBX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2020 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.48756944468698105,
		"percent_rated_long": 0.497705420154904,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BEY": {
		"fund_id": "FSUSA00IKT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2020 R",
		"ticker": "RRTBX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2020 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.48756944468698105,
		"percent_rated_long": 0.497705420154904,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BEZ": {
		"fund_id": "FSUSA00IKU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2030 R",
		"ticker": "RRTCX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2030 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.6328073168140036,
		"percent_rated_long": 0.6457335452887613,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA02VNC": {
		"fund_id": "FSUSA00IKU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2030",
		"ticker": "TRRCX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2030 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.6328073168140036,
		"percent_rated_long": 0.6457335452887613,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGK6": {
		"fund_id": "FSUSA00IKU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2030 I",
		"ticker": "TRFHX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2030 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.6328073168140036,
		"percent_rated_long": 0.6457335452887613,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA02VND": {
		"fund_id": "FSUSA00IKV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2040",
		"ticker": "TRRDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2040 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.8501159738248899,
		"percent_rated_long": 0.8590519371147507,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA04BF0": {
		"fund_id": "FSUSA00IKV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2040 R",
		"ticker": "RRTDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2040 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.8501159738248899,
		"percent_rated_long": 0.8590519371147507,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGK4": {
		"fund_id": "FSUSA00IKV",
		"investment_vehicle_name": "T. Rowe Price Retirement 2040 I",
		"ticker": "TRHDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2040 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.8501159738248899,
		"percent_rated_long": 0.8590519371147507,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA02VNS": {
		"fund_id": "FSUSA00IOH",
		"investment_vehicle_name": "AMG TimesSquare Small Cap Growth Z",
		"ticker": "TSCIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "AMG TimesSquare Small Cap Growth Fund",
		"fund_family_label": "AMG Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9436380020351691,
		"percent_rated_long": 0.9436380020351691,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000WZNJ": {
		"fund_id": "FSUSA0041D",
		"investment_vehicle_name": "T. Rowe Price Health Sciences I",
		"ticker": "THISX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "T. Rowe Price Health Sciences Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9019397477730549,
		"percent_rated_long": 0.9019397477730549,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA02VUW": {
		"fund_id": "FSUSA00J1X",
		"investment_vehicle_name": "Nuveen Large Cap Value R6",
		"ticker": "TRLIX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Large Cap Value Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9949016863875512,
		"percent_rated_long": 0.9949016863875512,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"FOUSA00B2S": {
		"fund_id": "FSUSA00016",
		"investment_vehicle_name": "American Beacon Large Cap Value R5",
		"ticker": "AADEX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Large Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.945548354688992,
		"percent_rated_long": 0.945548354688992,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F000002YE3": {
		"fund_id": "FSUSA00016",
		"investment_vehicle_name": "American Beacon Large Cap Value Y",
		"ticker": "ABLYX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Large Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.945548354688992,
		"percent_rated_long": 0.945548354688992,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000YM9F": {
		"fund_id": "FSUSA00016",
		"investment_vehicle_name": "American Beacon Large Cap Value R6",
		"ticker": "AALRX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Large Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.945548354688992,
		"percent_rated_long": 0.945548354688992,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000ISUB": {
		"fund_id": "FSUSA0AWPD",
		"investment_vehicle_name": "Vanguard Target Retirement 2055 Fund",
		"ticker": "VFFVX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2055 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8482452899843993,
		"percent_rated_long": 0.8655100989415139,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA02VXF": {
		"fund_id": "FSUSA00JFA",
		"investment_vehicle_name": "Nuveen Quant Mid Cap Growth R6",
		"ticker": "TRPWX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Quant Mid Cap Growth Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9958484552249608,
		"percent_rated_long": 0.9958484552249608,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA02VXI": {
		"fund_id": "FSUSA00JFC",
		"investment_vehicle_name": "Nuveen Mid Cap Value R6",
		"ticker": "TIMVX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Mid Cap Value Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9929423188012928,
		"percent_rated_long": 0.9929423188012928,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 5,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA02VXK": {
		"fund_id": "FSUSA00JFE",
		"investment_vehicle_name": "Nuveen Small Cap Blend Idx R6",
		"ticker": "TISBX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Small Cap Blend Index Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9908876986043929,
		"percent_rated_long": 0.9908876986043929,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA02VXM": {
		"fund_id": "FSUSA00JFF",
		"investment_vehicle_name": "Nuveen Quant Small Cap Equity R6",
		"ticker": "TISEX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Nuveen Quant Small Cap Equity Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9907408577426682,
		"percent_rated_long": 0.9907408577426682,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA02VXS": {
		"fund_id": "FSUSA00JFJ",
		"investment_vehicle_name": "Nuveen Real Estate Sec Sel R6",
		"ticker": "TIREX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Nuveen Real Estate Securities Select Fund",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9837295299457693,
		"percent_rated_long": 0.9837295299457693,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA00F0N": {
		"fund_id": "FSUSA002BE",
		"investment_vehicle_name": "State Street S&P 500 Index N",
		"ticker": "SVSPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "State Street S&P 500 Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9853516609539587,
		"percent_rated_long": 0.9853516609539587,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FOUSA00F2R": {
		"fund_id": "FSUSA002CH",
		"investment_vehicle_name": "Columbia Seligman Tech & Info A",
		"ticker": "SLMCX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Columbia Seligman Technology and Information Fund",
		"fund_family_label": "Columbia Threadneedle",
		"sustainable_investment": 0,
		"percent_rated": 0.9696875400716167,
		"percent_rated_long": 0.9709257372264054,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000J3JX": {
		"fund_id": "FSUSA0AXVG",
		"investment_vehicle_name": "Vanguard S&P Mid-Cap 400 Index I",
		"ticker": "VSPMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard S&P Mid-Cap 400 Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9982660485918576,
		"percent_rated_long": 0.9982660485918576,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000J3KB": {
		"fund_id": "FSUSA0AXVN",
		"investment_vehicle_name": "Vanguard Russell 1000 Value Index I",
		"ticker": "VRVIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Russell 1000 Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9992464025565917,
		"percent_rated_long": 0.9994808608734398,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000J3K7": {
		"fund_id": "FSUSA0AXVO",
		"investment_vehicle_name": "Vanguard Russell 1000 Growth Index I",
		"ticker": "VRGWX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Russell 1000 Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9996921557268239,
		"percent_rated_long": 0.9996921557268239,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000J3KF": {
		"fund_id": "FSUSA0AXVP",
		"investment_vehicle_name": "Vanguard Russell 2000 Index I",
		"ticker": "VRTIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Russell 2000 Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9789913766972014,
		"percent_rated_long": 0.9789913766972014,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000J3KD": {
		"fund_id": "FSUSA0AXVR",
		"investment_vehicle_name": "Vanguard Russell 2000 Growth Index I",
		"ticker": "VRTGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Russell 2000 Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9905589893987864,
		"percent_rated_long": 0.9905589893987864,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000WOUK": {
		"fund_id": "FSUSA0016N",
		"investment_vehicle_name": "Harbor Capital Appreciation Retirement",
		"ticker": "HNACX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Harbor Capital Appreciation Fund",
		"fund_family_label": "Harbor",
		"sustainable_investment": 0,
		"percent_rated": 0.9879351359186044,
		"percent_rated_long": 0.9879351359186044,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"FOUSA00D2I": {
		"fund_id": "FSUSA0016N",
		"investment_vehicle_name": "Harbor Capital Appreciation Instl",
		"ticker": "HACAX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Harbor Capital Appreciation Fund",
		"fund_family_label": "Harbor",
		"sustainable_investment": 0,
		"percent_rated": 0.9879351359186044,
		"percent_rated_long": 0.9879351359186044,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 2
	},
	"F00000MMWN": {
		"fund_id": "FSUSA00439",
		"investment_vehicle_name": "Carillon Eagle Mid Cap Growth R6",
		"ticker": "HRAUX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Carillon Eagle Mid Cap Growth Fund",
		"fund_family_label": "Carillon Family of Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9959370303794836,
		"percent_rated_long": 0.9959370303794836,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA02V3O": {
		"fund_id": "FSUSA00023",
		"investment_vehicle_name": "American Funds American Balanced R4",
		"ticker": "RLBEX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds American Balanced Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.6340576609378975,
		"percent_rated_long": 0.6406174525920979,
		"grade_fossil": 4,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F000002PJG": {
		"fund_id": "FSUSA00023",
		"investment_vehicle_name": "American Funds American Balanced R6",
		"ticker": "RLBGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds American Balanced Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.6340576609378975,
		"percent_rated_long": 0.6406174525920979,
		"grade_fossil": 4,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F00000PW2C": {
		"fund_id": "FSUSA0044H",
		"investment_vehicle_name": "Franklin Small Cap Growth R6",
		"ticker": "FSMLX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Franklin Small Cap Growth Fund",
		"fund_family_label": "Franklin Templeton Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.93172445125338,
		"percent_rated_long": 0.93172445125338,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000JS7I": {
		"fund_id": "FSUSA0044N",
		"investment_vehicle_name": "MassMutual Mid Cap Growth I",
		"ticker": "MEFZX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MassMutual Mid Cap Growth Fund",
		"fund_family_label": "MassMutual",
		"sustainable_investment": 0,
		"percent_rated": 0.9821794684986925,
		"percent_rated_long": 0.9821794684986925,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000MT9D": {
		"fund_id": "FSUSA0017G",
		"investment_vehicle_name": "JPMorgan Mid Cap Growth R6",
		"ticker": "JMGMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan Mid Cap Growth Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9717353793813063,
		"percent_rated_long": 0.9717353793813063,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F000010OEU": {
		"fund_id": "FS0000DV7D",
		"investment_vehicle_name": "Fidelity Freedom Blend Inc K",
		"ticker": "FHHEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend Income Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.1794829304389116,
		"percent_rated_long": 0.19422489814008229,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OET": {
		"fund_id": "FS0000DV7D",
		"investment_vehicle_name": "Fidelity Freedom Blend Inc K6",
		"ticker": "FHRDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend Income Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.1794829304389116,
		"percent_rated_long": 0.19422489814008229,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OF5": {
		"fund_id": "FS0000DV7E",
		"investment_vehicle_name": "Fidelity Freedom Blend 2045 K",
		"ticker": "FHXDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2045 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8016929088030538,
		"percent_rated_long": 0.8517092960177314,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00B74": {
		"fund_id": "FSUSA00031",
		"investment_vehicle_name": "Fidelity International Capital Apprec",
		"ticker": "FIVFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity International Capital Appreciation Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9759470400225931,
		"percent_rated_long": 0.9822704117738318,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 2
	},
	"F00000QT2A": {
		"fund_id": "FS0000AGHS",
		"investment_vehicle_name": "State Street Glb All Cap Eq ex-US Idx K",
		"ticker": "SSGLX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "International Equity Funds",
		"fund_legal_name": "State Street Global All Cap Equity ex-U.S. Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9257813212462509,
		"percent_rated_long": 0.9257813212462509,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000W4VL": {
		"fund_id": "FS0000AGI5",
		"investment_vehicle_name": "Goldman Sachs Small/Mid Cap Value R6",
		"ticker": "GMCUX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Goldman Sachs Small/Mid Cap Value Fund",
		"fund_family_label": "Goldman Sachs",
		"sustainable_investment": 0,
		"percent_rated": 0.980135258586319,
		"percent_rated_long": 0.980135258586319,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000Z6HF": {
		"fund_id": "FSUSA0776G",
		"investment_vehicle_name": "Carillon Scout Mid Cap R-6",
		"ticker": "CSMUX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Carillon Scout Mid Cap Fund",
		"fund_family_label": "Carillon Family of Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9992950741018686,
		"percent_rated_long": 0.9993131264583608,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F000010OF4": {
		"fund_id": "FS0000DV7E",
		"investment_vehicle_name": "Fidelity Freedom Blend 2045 K6",
		"ticker": "FHFDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2045 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8016929088030538,
		"percent_rated_long": 0.8517092960177314,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OFR": {
		"fund_id": "FS0000DV7G",
		"investment_vehicle_name": "Fidelity Freedom Blend 2055 K",
		"ticker": "FHVDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2055 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8018080413978556,
		"percent_rated_long": 0.8517781863546269,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OFS": {
		"fund_id": "FS0000DV7G",
		"investment_vehicle_name": "Fidelity Freedom Blend 2055 K6",
		"ticker": "FHDDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2055 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8018080413978556,
		"percent_rated_long": 0.8517781863546269,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OFV": {
		"fund_id": "FS0000DV7H",
		"investment_vehicle_name": "Fidelity Freedom Blend 2060 K",
		"ticker": "FHTDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2060 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8019882314105929,
		"percent_rated_long": 0.8518885118904217,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OFU": {
		"fund_id": "FS0000DV7H",
		"investment_vehicle_name": "Fidelity Freedom Blend 2060 K6",
		"ticker": "FHCDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2060 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8019882314105929,
		"percent_rated_long": 0.8518885118904217,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OGE": {
		"fund_id": "FS0000DV7K",
		"investment_vehicle_name": "Fidelity Freedom Blend 2010 K",
		"ticker": "FHFEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2010 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.23228321637223792,
		"percent_rated_long": 0.25103366928629156,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OGD": {
		"fund_id": "FS0000DV7K",
		"investment_vehicle_name": "Fidelity Freedom Blend 2010 K6",
		"ticker": "FHPDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2010 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.23228321637223792,
		"percent_rated_long": 0.25103366928629156,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OJI": {
		"fund_id": "FS0000DV8S",
		"investment_vehicle_name": "Fidelity Freedom Blend 2015 K",
		"ticker": "FHEEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2015 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.30823423263869915,
		"percent_rated_long": 0.3327250492690677,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OJH": {
		"fund_id": "FS0000DV8S",
		"investment_vehicle_name": "Fidelity Freedom Blend 2015 K6",
		"ticker": "FHODX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2015 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.30823423263869915,
		"percent_rated_long": 0.3327250492690677,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA02VJ6": {
		"fund_id": "FSUSA04AR6",
		"investment_vehicle_name": "Fidelity International Small Cap",
		"ticker": "FISMX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity International Small Cap Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9452983972339276,
		"percent_rated_long": 0.9454237196180219,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 3
	},
	"F00000QT2D": {
		"fund_id": "FSUSA04AUI",
		"investment_vehicle_name": "State Street Equity 500 Index K",
		"ticker": "SSSYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "State Street Equity 500 Index Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9853516609539587,
		"percent_rated_long": 0.9853516609539587,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"F00000W208": {
		"fund_id": "FSUSA002F2",
		"investment_vehicle_name": "Hartford Schroders US Small Cap Opps SDR",
		"ticker": "SCURX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Hartford Schroders US Small Cap Opportunities Fund",
		"fund_family_label": "Hartford Mutual Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.963085157242395,
		"percent_rated_long": 0.963085157242395,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 3,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F000002PJF": {
		"fund_id": "FSUSA002F6",
		"investment_vehicle_name": "American Funds SMALLCAP World R6",
		"ticker": "RLLGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds SMALLCAP World Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9423072417427563,
		"percent_rated_long": 0.9455273038698278,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"FOUSA08635": {
		"fund_id": "FSUSA0003O",
		"investment_vehicle_name": "MFS International Intrinsic Value R3",
		"ticker": "MINGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "MFS International Intrinsic Value Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9703336164638885,
		"percent_rated_long": 0.9703336164638885,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA02T5B": {
		"fund_id": "FSUSA0047P",
		"investment_vehicle_name": "Artisan Mid Cap Institutional",
		"ticker": "APHMX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Artisan Mid Cap Fund",
		"fund_family_label": "Artisan Partners Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.9708687633387575,
		"percent_rated_long": 0.9708687633387575,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"FOUSA05JIX": {
		"fund_id": "FSUSA077OL",
		"investment_vehicle_name": "Westwood Quality SmallCap Fund Inst",
		"ticker": "WHGSX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Westwood Quality SmallCap Fund",
		"fund_family_label": "Westwood",
		"sustainable_investment": 0,
		"percent_rated": 0.9982584835303386,
		"percent_rated_long": 0.9982584835303386,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 2,
		"grade_military": 5,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F000010OJR": {
		"fund_id": "FS0000DV8T",
		"investment_vehicle_name": "Fidelity Freedom Blend 2020 K",
		"ticker": "FHCEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2020 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.38532649311569867,
		"percent_rated_long": 0.41539227847333393,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OJQ": {
		"fund_id": "FS0000DV8T",
		"investment_vehicle_name": "Fidelity Freedom Blend 2020 K6",
		"ticker": "FHNDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2020 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.38532649311569867,
		"percent_rated_long": 0.41539227847333393,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OK0": {
		"fund_id": "FS0000DV8U",
		"investment_vehicle_name": "Fidelity Freedom Blend 2025 K",
		"ticker": "FHBEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2025 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.4557977149979249,
		"percent_rated_long": 0.4904607569643226,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OJZ": {
		"fund_id": "FS0000DV8U",
		"investment_vehicle_name": "Fidelity Freedom Blend 2025 K6",
		"ticker": "FHLDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2025 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.4557977149979249,
		"percent_rated_long": 0.4904607569643226,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000010OK8": {
		"fund_id": "FS0000DV8V",
		"investment_vehicle_name": "Fidelity Freedom Blend 2030 K6",
		"ticker": "FHKDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2030 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.5135129795029129,
		"percent_rated_long": 0.5515555186877685,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OK9": {
		"fund_id": "FS0000DV8V",
		"investment_vehicle_name": "Fidelity Freedom Blend 2030 K",
		"ticker": "FHAEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2030 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.5135129795029129,
		"percent_rated_long": 0.5515555186877685,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OKI": {
		"fund_id": "FS0000DV8W",
		"investment_vehicle_name": "Fidelity Freedom Blend 2035 K",
		"ticker": "FHZDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2035 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.598343653320671,
		"percent_rated_long": 0.6410590277024039,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OKH": {
		"fund_id": "FS0000DV8W",
		"investment_vehicle_name": "Fidelity Freedom Blend 2035 K6",
		"ticker": "FHJDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2035 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.598343653320671,
		"percent_rated_long": 0.6410590277024039,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OKR": {
		"fund_id": "FS0000DV8X",
		"investment_vehicle_name": "Fidelity Freedom Blend 2040 K",
		"ticker": "FHYDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2040 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.7343665152249347,
		"percent_rated_long": 0.7819424724236245,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000010OKQ": {
		"fund_id": "FS0000DV8X",
		"investment_vehicle_name": "Fidelity Freedom Blend 2040 K6",
		"ticker": "FHHDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2040 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.7343665152249347,
		"percent_rated_long": 0.7819424724236245,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00B8C": {
		"fund_id": "FSUSA0003P",
		"investment_vehicle_name": "American Funds American Mutual A",
		"ticker": "AMRMX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Funds American Mutual Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9577329936953177,
		"percent_rated_long": 0.9577329936953177,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 5,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000J8KQ": {
		"fund_id": "FSUSA00045",
		"investment_vehicle_name": "Allspring Special Small Cap Value Inst",
		"ticker": "ESPNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Allspring Special Small Cap Value Fund",
		"fund_family_label": "Allspring Global Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.968526638566135,
		"percent_rated_long": 0.968618154689322,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA06SU9": {
		"fund_id": "FSUSA0048C",
		"investment_vehicle_name": "ClearBridge Small Cap Growth IS",
		"ticker": "LMOIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "ClearBridge Small Cap Growth Fund",
		"fund_family_label": "Franklin Templeton Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9529165640407704,
		"percent_rated_long": 0.9539405086786833,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F000002PJ9": {
		"fund_id": "FSUSA0049G",
		"investment_vehicle_name": "American Funds New World R6",
		"ticker": "RNWGX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "American Funds New World Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.9345296018036915,
		"percent_rated_long": 0.9374981585120193,
		"grade_fossil": 4,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"F00000PBOJ": {
		"fund_id": "FSUSA002HP",
		"investment_vehicle_name": "MFS Mid Cap Growth R6",
		"ticker": "OTCKX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "MFS Mid Cap Growth Fund",
		"fund_family_label": "MFS",
		"sustainable_investment": 0,
		"percent_rated": 0.9848511804262058,
		"percent_rated_long": 0.9848511804262058,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000N785": {
		"fund_id": "FSUSA0004M",
		"investment_vehicle_name": "Ariel Fund Institutional",
		"ticker": "ARAIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Ariel Fund",
		"fund_family_label": "Ariel Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9935125292842091,
		"percent_rated_long": 0.9935125292842091,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00001GGK2": {
		"fund_id": "FS0000AOEU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2060 I",
		"ticker": "TRLNX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2060 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9538084729121917,
		"percent_rated_long": 0.9564389219101156,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000SZHY": {
		"fund_id": "FS0000AOEU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2060 R",
		"ticker": "TRRZX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2060 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9538084729121917,
		"percent_rated_long": 0.9564389219101156,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000SZHW": {
		"fund_id": "FS0000AOEU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2060",
		"ticker": "TRRLX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2060 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9538084729121917,
		"percent_rated_long": 0.9564389219101156,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00000Q3F3": {
		"fund_id": "FSUSA07HW9",
		"investment_vehicle_name": "BNY Mellon Developed Markets RE Scs - Y",
		"ticker": "DRLYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "BNY Mellon Developed Markets Real Estate Securities Fund",
		"fund_family_label": "BNY Mellon",
		"sustainable_investment": 0,
		"percent_rated": 0.9937092131939987,
		"percent_rated_long": 0.9949506043930733,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000OB9Z": {
		"fund_id": "FSUSA001B1",
		"investment_vehicle_name": "Janus Henderson Enterprise N",
		"ticker": "JDMNX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Janus Henderson Enterprise Fund",
		"fund_family_label": "Janus Henderson",
		"sustainable_investment": 0,
		"percent_rated": 0.9578433685233885,
		"percent_rated_long": 0.9578433685233885,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000WJF7": {
		"fund_id": "FSUSA00069",
		"investment_vehicle_name": "Baron Asset R6",
		"ticker": "BARUX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Baron Asset Fund",
		"fund_family_label": "Baron Capital Group, Inc.",
		"sustainable_investment": 0,
		"percent_rated": 0.9203641379808667,
		"percent_rated_long": 0.9215185821013915,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00001GGJZ": {
		"fund_id": "FSUSA07VNU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2055 I",
		"ticker": "TRJMX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2055 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9545018534461911,
		"percent_rated_long": 0.9563984392119675,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA068A1": {
		"fund_id": "FSUSA07VNU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2055",
		"ticker": "TRRNX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2055 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9545018534461911,
		"percent_rated_long": 0.9563984392119675,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA04B9B": {
		"fund_id": "FSUSA04BYK",
		"investment_vehicle_name": "Vanguard Target Retirement Income Fund",
		"ticker": "VTINX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement Income",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.234703361764501,
		"percent_rated_long": 0.2581225491484971,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BAX": {
		"fund_id": "FSUSA04BZU",
		"investment_vehicle_name": "PIMCO All Asset All Authority Inst",
		"ticker": "PAUIX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "PIMCO All Asset All Authority Fund",
		"fund_family_label": "PIMCO",
		"sustainable_investment": 0,
		"percent_rated": 0.011995805753288338,
		"percent_rated_long": 0.021218041530431088,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04BCR": {
		"fund_id": "FSUSA04C0R",
		"investment_vehicle_name": "T. Rowe Price Instl Large Cap Core Gr",
		"ticker": "TPLGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Institutional Large Cap Core Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9846182195137934,
		"percent_rated_long": 0.9846182195137934,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000JSGY": {
		"fund_id": "FSUSA002IK",
		"investment_vehicle_name": "JPMorgan Large Cap Growth R6",
		"ticker": "JLGMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "JPMorgan Large Cap Growth Fund",
		"fund_family_label": "JPMorgan",
		"sustainable_investment": 0,
		"percent_rated": 0.9336883890301371,
		"percent_rated_long": 0.9336883890301371,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 4
	},
	"F00000T8XO": {
		"fund_id": "FS0000AREB",
		"investment_vehicle_name": "State Street Target Retirement 2055 K",
		"ticker": "SSDQX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2055 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.8533577725535787,
		"percent_rated_long": 0.8533577725535787,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000T8XS": {
		"fund_id": "FS0000AREC",
		"investment_vehicle_name": "State Street Target Retirement 2060 K",
		"ticker": "SSDYX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2060 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.8533254155291081,
		"percent_rated_long": 0.8533254155291081,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000T8Y5": {
		"fund_id": "FS0000AREG",
		"investment_vehicle_name": "State Street Equity 500 Index II",
		"ticker": "SSEYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "State Street Equity 500 Index II Portfolio",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9492290385926833,
		"percent_rated_long": 0.9492290385926833,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"F00000T8Y8": {
		"fund_id": "FS0000AREJ",
		"investment_vehicle_name": "State Street Glb All Cap Eq ex-US Idx",
		"ticker": "SSGVX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "State Street Global All Cap Equity ex-U.S.Index Portfolio",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.9257813212462508,
		"percent_rated_long": 0.9257813212462508,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000T8YC": {
		"fund_id": "FS0000AREK",
		"investment_vehicle_name": "State Street Target Retirement K",
		"ticker": "SSFOX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.33812663034850676,
		"percent_rated_long": 0.33812663034850676,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000T8YK": {
		"fund_id": "FS0000AREM",
		"investment_vehicle_name": "State Street Target Retirement 2020 K",
		"ticker": null,
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2020 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.3378760417587632,
		"percent_rated_long": 0.3378760417587632,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000T8YO": {
		"fund_id": "FS0000AREN",
		"investment_vehicle_name": "State Street Target Retirement 2025 K",
		"ticker": "SSBSX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2025 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.4563979271794572,
		"percent_rated_long": 0.4563979271794572,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000T8YS": {
		"fund_id": "FS0000AREO",
		"investment_vehicle_name": "State Street Target Retirement 2030 K",
		"ticker": "SSBYX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2030 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.572891647924484,
		"percent_rated_long": 0.572891647924484,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA06BXM": {
		"fund_id": "FSUSA07VNU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2055 R",
		"ticker": "RRTVX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2055 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9545018534461911,
		"percent_rated_long": 0.9563984392119675,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F000002POB": {
		"fund_id": "FSUSA07X41",
		"investment_vehicle_name": "American Funds 2010 Trgt Date Retire R6",
		"ticker": "RFTTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2010 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.3900847695247651,
		"percent_rated_long": 0.39289811053031937,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000002Q7R": {
		"fund_id": "FSUSA07X42",
		"investment_vehicle_name": "American Funds 2015 Trgt Date Retire R6",
		"ticker": "RFJTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2015 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.3986546299944059,
		"percent_rated_long": 0.4010271502634278,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000002QON": {
		"fund_id": "FSUSA07X44",
		"investment_vehicle_name": "American Funds 2020 Trgt Date Retire R6",
		"ticker": "RRCTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2020 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.44620455755237143,
		"percent_rated_long": 0.449209943083578,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA04B9A": {
		"fund_id": "FSUSA04C61",
		"investment_vehicle_name": "Vanguard Target Retirement 2045 Fund",
		"ticker": "VTIVX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2045 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.7630092219321544,
		"percent_rated_long": 0.7885721792750358,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA04B99": {
		"fund_id": "FSUSA04C62",
		"investment_vehicle_name": "Vanguard Target Retirement 2035 Fund",
		"ticker": "VTTHX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2035 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.5890101429687177,
		"percent_rated_long": 0.6254913601004382,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA04B98": {
		"fund_id": "FSUSA04C63",
		"investment_vehicle_name": "Vanguard Target Retirement 2025 Fund",
		"ticker": "VTTVX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Target Retirement 2025 Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.42108873096180166,
		"percent_rated_long": 0.45545887127229084,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000MJRM": {
		"fund_id": "FSUSA004DM",
		"investment_vehicle_name": "Fidelity International Index",
		"ticker": "FSPSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity International Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.937636019125734,
		"percent_rated_long": 0.9545564272550395,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA05U9B": {
		"fund_id": "FSUSA004E1",
		"investment_vehicle_name": "Touchstone Value Institutional",
		"ticker": "TVLIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Touchstone Value Fund",
		"fund_family_label": "Touchstone",
		"sustainable_investment": 0,
		"percent_rated": 0.9652546588635752,
		"percent_rated_long": 0.9652546588635752,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 5
	},
	"FOUSA00K3X": {
		"fund_id": "FSUSA0008G",
		"investment_vehicle_name": "Artisan International Institutional",
		"ticker": "APHIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Artisan International Fund",
		"fund_family_label": "Artisan Partners Funds",
		"sustainable_investment": 0,
		"percent_rated": 0.897995061215855,
		"percent_rated_long": 0.897995061215855,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 5
	},
	"F00000T8YW": {
		"fund_id": "FS0000AREP",
		"investment_vehicle_name": "State Street Target Retirement 2035 K",
		"ticker": "SSCKX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2035 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.661222772936004,
		"percent_rated_long": 0.661222772936004,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000T8Z0": {
		"fund_id": "FS0000AREQ",
		"investment_vehicle_name": "State Street Target Retirement 2040 K",
		"ticker": "SSCQX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2040 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.7318617163214692,
		"percent_rated_long": 0.7318617163214692,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000T8Z4": {
		"fund_id": "FS0000ARER",
		"investment_vehicle_name": "State Street Target Retirement 2045 K",
		"ticker": "SSDEX",
		"portfolio_date": "2025-01-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "State Street Target Retirement 2045 Fund",
		"fund_family_label": "State Street",
		"sustainable_investment": 0,
		"percent_rated": 0.7885118156435426,
		"percent_rated_long": 0.7885118156435426,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000002Q7T": {
		"fund_id": "FSUSA07X47",
		"investment_vehicle_name": "American Funds 2025 Trgt Date Retire R6",
		"ticker": "RFDTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2025 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.46181315625962804,
		"percent_rated_long": 0.46488845819060337,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F000002Q7X": {
		"fund_id": "FSUSA07X4B",
		"investment_vehicle_name": "American Funds 2030 Trgt Date Retire R6",
		"ticker": "RFETX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2030 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.5705315964422643,
		"percent_rated_long": 0.5740162380225858,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F000002Q7U": {
		"fund_id": "FSUSA07X4D",
		"investment_vehicle_name": "American Funds 2035 Trgt Date Retire R6",
		"ticker": "RFFTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2035 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.6643761213388961,
		"percent_rated_long": 0.667279553322147,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"FOUSA04BJY": {
		"fund_id": "FSUSA04CED",
		"investment_vehicle_name": "William Blair Small-Mid Cap Growth I",
		"ticker": "WSMDX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "William Blair Small-Mid Cap Growth Fund",
		"fund_family_label": "William Blair",
		"sustainable_investment": 0,
		"percent_rated": 0.9662994851612818,
		"percent_rated_long": 0.9662994851612818,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F000013ARA": {
		"fund_id": "FSUSA04CED",
		"investment_vehicle_name": "William Blair Small-Mid Cap Growth R6",
		"ticker": "WSMRX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "William Blair Small-Mid Cap Growth Fund",
		"fund_family_label": "William Blair",
		"sustainable_investment": 0,
		"percent_rated": 0.9662994851612818,
		"percent_rated_long": 0.9662994851612818,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 4,
		"grade_deforestation": 1,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"FOUSA04BN7": {
		"fund_id": "FSUSA04CI3",
		"investment_vehicle_name": "Vanguard Large Cap Index Admiral",
		"ticker": "VLCAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Large Cap Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9990177827072996,
		"percent_rated_long": 0.9990177827072996,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"F000014VOK": {
		"fund_id": "FSUSA0009Z",
		"investment_vehicle_name": "T. Rowe Price Emerging Markets Stock Z",
		"ticker": "TRGZX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "T. Rowe Price Emerging Markets Stock Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9570287605140102,
		"percent_rated_long": 0.9570287605140102,
		"grade_fossil": 4,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": -1,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F000002PE0": {
		"fund_id": "FSUSA002JL",
		"investment_vehicle_name": "Baron Growth Instl",
		"ticker": "BGRIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Baron Growth Fund",
		"fund_family_label": "Baron Capital Group, Inc.",
		"sustainable_investment": 0,
		"percent_rated": 0.9997611869871997,
		"percent_rated_long": 0.9998897975105875,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000VQ8G": {
		"fund_id": "FS0000ASQV",
		"investment_vehicle_name": "Fidelity Freedom Index 2060 Instl Prem",
		"ticker": "FFLEX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2060 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.869088320235578,
		"percent_rated_long": 0.8776290996247407,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F0000154M7": {
		"fund_id": "FS0000ASQV",
		"investment_vehicle_name": "Fidelity Freedom Index 2060 Premier",
		"ticker": "FUIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2060 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.869088320235578,
		"percent_rated_long": 0.8776290996247407,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F000013DJ9": {
		"fund_id": "FS0000F7H8",
		"investment_vehicle_name": "Fidelity Freedom Blend 2065 K",
		"ticker": "FFBKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2065 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8021976675418592,
		"percent_rated_long": 0.8519889527587764,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000013DJA": {
		"fund_id": "FS0000F7H8",
		"investment_vehicle_name": "Fidelity Freedom Blend 2065 K6",
		"ticker": "FFBQX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Blend 2065 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8021976675418592,
		"percent_rated_long": 0.8519889527587764,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000013DKQ": {
		"fund_id": "FS0000F7H9",
		"investment_vehicle_name": "Fidelity Freedom Index 2065 Instl Prem",
		"ticker": "FFIKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2065 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690802861644025,
		"percent_rated_long": 0.8776239214339288,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F0000154M8": {
		"fund_id": "FS0000F7H9",
		"investment_vehicle_name": "Fidelity Freedom Index 2065 Premier",
		"ticker": "FVIPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2065 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690802861644025,
		"percent_rated_long": 0.8776239214339288,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F000002Q7Y": {
		"fund_id": "FSUSA07X4E",
		"investment_vehicle_name": "American Funds 2040 Trgt Date Retire R6",
		"ticker": "RFGTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2040 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.8093588362497989,
		"percent_rated_long": 0.8110271795211329,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F000002Q7V": {
		"fund_id": "FSUSA07X4G",
		"investment_vehicle_name": "American Funds 2045 Trgt Date Retire R6",
		"ticker": "RFHTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2045 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.8567475288554358,
		"percent_rated_long": 0.8585656029079803,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"FOUSA04BNE": {
		"fund_id": "FSUSA04CI9",
		"investment_vehicle_name": "Vanguard Information Technology Idx Adm",
		"ticker": "VITAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Vanguard Information Technology Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9955314367058837,
		"percent_rated_long": 0.9956492137338626,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 2,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"F00000YWTN": {
		"fund_id": "FSUSA04CIE",
		"investment_vehicle_name": "T. Rowe Price Diversified Mid Cap Gr I",
		"ticker": "RPTTX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "T. Rowe Price Diversified Mid Cap Growth Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.9891488698349453,
		"percent_rated_long": 0.9891488698349453,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 1
	},
	"F00000MAOX": {
		"fund_id": "FSUSA0BDPS",
		"investment_vehicle_name": "BlackRock LifePath® Index Retire K",
		"ticker": "LIRKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index Retirement Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.36014263415604697,
		"percent_rated_long": 0.36602940140857254,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00000MAP0": {
		"fund_id": "FSUSA0BDPT",
		"investment_vehicle_name": "BlackRock LifePath® Index 2055 K",
		"ticker": "LIVKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2055 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9593392007334665,
		"percent_rated_long": 0.9673572553571502,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000MAPH": {
		"fund_id": "FSUSA0BDPV",
		"investment_vehicle_name": "BlackRock LifePath® Index 2045 K",
		"ticker": "LIHKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2045 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.8432328962371524,
		"percent_rated_long": 0.8525947080353896,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000MAPI": {
		"fund_id": "FSUSA0BDPW",
		"investment_vehicle_name": "BlackRock LifePath® Index 2040 K",
		"ticker": "LIKKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2040 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.7371352270788867,
		"percent_rated_long": 0.746783388859974,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000MAPJ": {
		"fund_id": "FSUSA0BDPX",
		"investment_vehicle_name": "BlackRock LifePath® Index 2035 K",
		"ticker": "LIJKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2035 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.6244949337924726,
		"percent_rated_long": 0.6341916397609071,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000MAPK": {
		"fund_id": "FSUSA0BDPY",
		"investment_vehicle_name": "BlackRock LifePath® Index 2030 K",
		"ticker": "LINKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2030 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.5012846603376494,
		"percent_rated_long": 0.5092324892861642,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA009MW": {
		"fund_id": "FSUSA004F4",
		"investment_vehicle_name": "American Beacon Small Cp Val R5",
		"ticker": "AVFIX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Small Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.9286486905822149,
		"percent_rated_long": 0.9286486905822149,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F000002YE4": {
		"fund_id": "FSUSA004F4",
		"investment_vehicle_name": "American Beacon Small Cp Val Y",
		"ticker": "ABSYX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Small Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.9286486905822149,
		"percent_rated_long": 0.9286486905822149,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000YDJB": {
		"fund_id": "FSUSA004F4",
		"investment_vehicle_name": "American Beacon Small Cap Value R6",
		"ticker": "AASRX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Beacon Small Cap Value Fund",
		"fund_family_label": "American Beacon",
		"sustainable_investment": 0,
		"percent_rated": 0.9286486905822149,
		"percent_rated_long": 0.9286486905822149,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00FIG": {
		"fund_id": "FSUSA002L7",
		"investment_vehicle_name": "Vanguard International Value Inv",
		"ticker": "VTRIX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard International Value Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.954424820494723,
		"percent_rated_long": 0.9603627530106111,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F000013FUR": {
		"fund_id": "FS0000F98E",
		"investment_vehicle_name": "Fidelity Growth Company K6",
		"ticker": "FGKFX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Growth Company K6 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9635316035931243,
		"percent_rated_long": 0.9637539746277691,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 4
	},
	"F00000JXVR": {
		"fund_id": "FSUSA07YWA",
		"investment_vehicle_name": "Vanguard FTSE All-Wld ex-US Idx Ins Plus",
		"ticker": "VFWPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard FTSE All-World ex-US Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9670080950231761,
		"percent_rated_long": 0.970005318493565,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000PW1K": {
		"fund_id": "FSUSA004FL",
		"investment_vehicle_name": "Franklin Small Cap Value R6",
		"ticker": "FRCSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Franklin Small Cap Value Fund",
		"fund_family_label": "Franklin Templeton Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.975889771728346,
		"percent_rated_long": 0.975889771728346,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000U3BB": {
		"fund_id": "FS0000AZL4",
		"investment_vehicle_name": "AB Global Core Equity Advisor",
		"ticker": "GCEYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "AB Global Core Equity Portfolio",
		"fund_family_label": "AllianceBernstein",
		"sustainable_investment": 0,
		"percent_rated": 1,
		"percent_rated_long": 1,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F000013OYO": {
		"fund_id": "FS0000FCWA",
		"investment_vehicle_name": "BlackRock LifePath® Index 2065 K",
		"ticker": "LIWKX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "BlackRock LifePath® Index 2065 Fund",
		"fund_family_label": "BlackRock/iShares",
		"sustainable_investment": 0,
		"percent_rated": 0.9632645516288987,
		"percent_rated_long": 0.9719865569439395,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA06B5B": {
		"fund_id": "FSUSA07YWA",
		"investment_vehicle_name": "Vanguard FTSE All-Wld ex-US Idx Instl",
		"ticker": "VFWSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard FTSE All-World ex-US Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9670080950231761,
		"percent_rated_long": 0.970005318493565,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA05659": {
		"fund_id": "FSUSA04WWR",
		"investment_vehicle_name": "T. Rowe Price Retirement 2005",
		"ticker": "TRRFX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2005 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.39764365126811596,
		"percent_rated_long": 0.4015188707973776,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00001GGKA": {
		"fund_id": "FSUSA04WWR",
		"investment_vehicle_name": "T. Rowe Price Retirement 2005 I",
		"ticker": "TRAJX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2005 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.39764365126811596,
		"percent_rated_long": 0.4015188707973776,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06BXC": {
		"fund_id": "FSUSA04WWR",
		"investment_vehicle_name": "T. Rowe Price Retirement 2005 R",
		"ticker": "RRTLX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2005 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.39764365126811596,
		"percent_rated_long": 0.4015188707973776,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"F00001GGK7": {
		"fund_id": "FSUSA04WWS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2015 I",
		"ticker": "TRUBX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2015 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.46180130798665603,
		"percent_rated_long": 0.47171941981794274,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA0565A": {
		"fund_id": "FSUSA04WWS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2015",
		"ticker": "TRRGX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2015 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.46180130798665603,
		"percent_rated_long": 0.47171941981794274,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA06BXE": {
		"fund_id": "FSUSA04WWS",
		"investment_vehicle_name": "T. Rowe Price Retirement 2015 R",
		"ticker": "RRTMX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2015 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.46180130798665603,
		"percent_rated_long": 0.47171941981794274,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"FOUSA0565B": {
		"fund_id": "FSUSA04WWT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2025",
		"ticker": "TRRHX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2025 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.5315612121861537,
		"percent_rated_long": 0.5438104136344886,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06BXG": {
		"fund_id": "FSUSA04WWT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2025 R",
		"ticker": "RRTNX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2025 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.5315612121861537,
		"percent_rated_long": 0.5438104136344886,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGK5": {
		"fund_id": "FSUSA04WWT",
		"investment_vehicle_name": "T. Rowe Price Retirement 2025 I",
		"ticker": "TREHX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2025 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.5315612121861537,
		"percent_rated_long": 0.5438104136344886,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA0565C": {
		"fund_id": "FSUSA04WWU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2035",
		"ticker": "TRRJX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2035 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.7551069159548631,
		"percent_rated_long": 0.7641311572566625,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA06BXI": {
		"fund_id": "FSUSA04WWU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2035 R",
		"ticker": "RRTPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2035 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.7551069159548631,
		"percent_rated_long": 0.7641311572566625,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"F00001GGK3": {
		"fund_id": "FSUSA04WWU",
		"investment_vehicle_name": "T. Rowe Price Retirement 2035 I",
		"ticker": "TRFJX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "T. Rowe Price Retirement 2035 Fund",
		"fund_family_label": "T. Rowe Price",
		"sustainable_investment": 0,
		"percent_rated": 0.7551069159548631,
		"percent_rated_long": 0.7641311572566625,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 3
	},
	"FOUSA04BCT": {
		"fund_id": "FSUSA04X80",
		"investment_vehicle_name": "Fidelity Nasdaq Composite Index",
		"ticker": "FNCMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Nasdaq Composite Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9949549744095804,
		"percent_rated_long": 0.9963725512575698,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 2
	},
	"FOUSA00KDL": {
		"fund_id": "FSUSA004HJ",
		"investment_vehicle_name": "Vanguard Selected Value Inv",
		"ticker": "VASVX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Selected Value Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9596627708341902,
		"percent_rated_long": 0.9600901751800981,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 5,
		"grade_military": 4,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000VVAG": {
		"fund_id": "FSUSA082GS",
		"investment_vehicle_name": "Columbia Disciplined Growth Inst3",
		"ticker": "CGQYX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Columbia Disciplined Growth Fund",
		"fund_family_label": "Columbia Threadneedle",
		"sustainable_investment": 0,
		"percent_rated": 0.9670025846642218,
		"percent_rated_long": 0.9783072899098636,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 2,
		"grade_tobacco": 1
	},
	"F00000VE8C": {
		"fund_id": "FSUSA0BFFH",
		"investment_vehicle_name": "Victory Integrity Small/Mid-Cap Value R6",
		"ticker": "MIRSX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Victory Integrity Small/Mid-Cap Value Fund",
		"fund_family_label": "Victory Capital",
		"sustainable_investment": 0,
		"percent_rated": 0.9860443042592549,
		"percent_rated_long": 0.9860443042592549,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 2
	},
	"F00000Q7J5": {
		"fund_id": "FSUSA04XKE",
		"investment_vehicle_name": "American Century Mid Cap Value R6",
		"ticker": "AMDVX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "American Century Mid Cap Value Fund",
		"fund_family_label": "American Century Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9878797317105611,
		"percent_rated_long": 0.9878797317105611,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"F00000NQI4": {
		"fund_id": "FSUSA004IW",
		"investment_vehicle_name": "Invesco Oppenheimer International Gr R6",
		"ticker": "OIGIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Invesco Oppenheimer International Growth Fund",
		"fund_family_label": "Invesco",
		"sustainable_investment": 0,
		"percent_rated": 0.9469999300650553,
		"percent_rated_long": 0.9518312267462959,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 1
	},
	"FOUSA02TYE": {
		"fund_id": "FSUSA004JF",
		"investment_vehicle_name": "Vanguard Real Estate Index Admiral",
		"ticker": "VGSLX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Vanguard Real Estate Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8544249340387216,
		"percent_rated_long": 0.8544249340387216,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"FOUSA04BEQ": {
		"fund_id": "FSUSA004JF",
		"investment_vehicle_name": "Vanguard Real Estate Index Institutional",
		"ticker": "VGSNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Vanguard Real Estate Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.8544249340387216,
		"percent_rated_long": 0.8544249340387216,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000JTEF": {
		"fund_id": "FSUSA004JJ",
		"investment_vehicle_name": "Vanguard Total Intl Stock Index Admiral",
		"ticker": "VTIAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total Intl Stock Idx Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9699672397144548,
		"percent_rated_long": 0.9701971938477687,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000JTBU": {
		"fund_id": "FSUSA004JJ",
		"investment_vehicle_name": "Vanguard Total Intl Stock Index I",
		"ticker": "VTSNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total Intl Stock Idx Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9699672397144548,
		"percent_rated_long": 0.9701971938477687,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000JTBV": {
		"fund_id": "FSUSA004JJ",
		"investment_vehicle_name": "Vanguard Total Intl Stock Idx InstlPls",
		"ticker": "VTPSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total Intl Stock Idx Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9699672397144548,
		"percent_rated_long": 0.9701971938477687,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00KIR": {
		"fund_id": "FSUSA004JJ",
		"investment_vehicle_name": "Vanguard Total Intl Stock Index Inv",
		"ticker": "VGTSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Vanguard Total Intl Stock Idx Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9699672397144548,
		"percent_rated_long": 0.9701971938477687,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000ULLF": {
		"fund_id": "FS0000B7PP",
		"investment_vehicle_name": "American Funds 2060 Trgt Date Retire R6",
		"ticker": "RFUTX",
		"portfolio_date": "2024-12-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "American Funds 2060 Target Date Retirement Fund®",
		"fund_family_label": "American Funds/Capital Group",
		"sustainable_investment": 0,
		"percent_rated": 0.8779748771815228,
		"percent_rated_long": 0.8799466693296464,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 5
	},
	"F00000VQ8F": {
		"fund_id": "FSUSA0BGOA",
		"investment_vehicle_name": "Fidelity Freedom Index 2055 Instl Prem",
		"ticker": "FFLDX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2055 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690919160499383,
		"percent_rated_long": 0.8776311523585386,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F0000154M6": {
		"fund_id": "FSUSA0BGOA",
		"investment_vehicle_name": "Fidelity Freedom Index 2055 Premier",
		"ticker": "FTYPX",
		"portfolio_date": "2025-02-28",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Fidelity Freedom Index 2055 Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.8690919160499383,
		"percent_rated_long": 0.8776311523585386,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000MJRI": {
		"fund_id": "FSUSA0BGZ9",
		"investment_vehicle_name": "Fidelity Global ex US Index",
		"ticker": "FSGGX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "Fidelity Global ex U.S. Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9321061223980612,
		"percent_rated_long": 0.951898098503749,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"F00000MJRP": {
		"fund_id": "FSUSA0BGZB",
		"investment_vehicle_name": "Fidelity Mid Cap Index",
		"ticker": "FSMDX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Mid Cap Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9922011535490238,
		"percent_rated_long": 0.9942382633613244,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 2
	},
	"F00000MJRT": {
		"fund_id": "FSUSA0BGZC",
		"investment_vehicle_name": "Fidelity Real Estate Index",
		"ticker": "FSRNX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Sector Equity Funds",
		"fund_legal_name": "Fidelity Real Estate Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.9968829281764833,
		"percent_rated_long": 0.9976757307520491,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_military": 1,
		"grade_prison_industrial_complex": 1,
		"grade_tobacco": 1
	},
	"F00000MJRV": {
		"fund_id": "FSUSA0BGZD",
		"investment_vehicle_name": "Fidelity Small Cap Index",
		"ticker": "FSSNX",
		"portfolio_date": "2025-01-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Fidelity Small Cap Index Fund",
		"fund_family_label": "Fidelity Investments",
		"sustainable_investment": 0,
		"percent_rated": 0.991837169475151,
		"percent_rated_long": 0.994291811750339,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00L7S": {
		"fund_id": "FSUSA002PK",
		"investment_vehicle_name": "Vanguard Balanced Index I",
		"ticker": "VBAIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "Allocation Funds",
		"fund_legal_name": "Vanguard Balanced Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.5980492339790293,
		"percent_rated_long": 0.5981128812601202,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA02TIM": {
		"fund_id": "FSUSA002PL",
		"investment_vehicle_name": "Vanguard Equity-Income Adm",
		"ticker": "VEIRX",
		"portfolio_date": "2024-12-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Equity Income Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9812725657531147,
		"percent_rated_long": 0.9812861017980881,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 1,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"F00000WTNQ": {
		"fund_id": "FSUSA002PR",
		"investment_vehicle_name": "Vanguard Extended Market Index Instl Sel",
		"ticker": "VSEMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Extended Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9836468182425383,
		"percent_rated_long": 0.9836468182425383,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00FQR": {
		"fund_id": "FSUSA002PR",
		"investment_vehicle_name": "Vanguard Extended Market Index Investor",
		"ticker": "VEXMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Extended Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9836468182425383,
		"percent_rated_long": 0.9836468182425383,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00LB6": {
		"fund_id": "FSUSA002PR",
		"investment_vehicle_name": "Vanguard Extended Market Index Admiral",
		"ticker": "VEXAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Extended Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9836468182425383,
		"percent_rated_long": 0.9836468182425383,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000JXVS": {
		"fund_id": "FSUSA002PR",
		"investment_vehicle_name": "Vanguard Extended Market Index InstlPlus",
		"ticker": "VEMPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Extended Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9836468182425383,
		"percent_rated_long": 0.9836468182425383,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"FOUSA00GPW": {
		"fund_id": "FSUSA002PR",
		"investment_vehicle_name": "Vanguard Extended Market Index Instl",
		"ticker": "VIEIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Extended Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9836468182425383,
		"percent_rated_long": 0.9836468182425383,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000VE7X": {
		"fund_id": "FSUSA002PT",
		"investment_vehicle_name": "Vanguard Total Stock Mkt Idx Instl Pls",
		"ticker": "VSMPX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Total Stock Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9957464372071257,
		"percent_rated_long": 0.9957464372071257,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00FQU": {
		"fund_id": "FSUSA002PT",
		"investment_vehicle_name": "Vanguard Total Stock Mkt Idx Inv",
		"ticker": "VTSMX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Total Stock Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9957464372071257,
		"percent_rated_long": 0.9957464372071257,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00L83": {
		"fund_id": "FSUSA002PT",
		"investment_vehicle_name": "Vanguard Total Stock Mkt Idx Adm",
		"ticker": "VTSAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Total Stock Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9957464372071257,
		"percent_rated_long": 0.9957464372071257,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00GQ7": {
		"fund_id": "FSUSA002PT",
		"investment_vehicle_name": "Vanguard Total Stock Market Idx I",
		"ticker": "VITSX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Total Stock Market Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9957464372071257,
		"percent_rated_long": 0.9957464372071257,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"FOUSA00JGS": {
		"fund_id": "FSUSA002PU",
		"investment_vehicle_name": "Vanguard Growth Index Institutional",
		"ticker": "VIGIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9993052406920615,
		"percent_rated_long": 0.9993052406920615,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA00L97": {
		"fund_id": "FSUSA002PU",
		"investment_vehicle_name": "Vanguard Growth Index Admiral",
		"ticker": "VIGAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Growth Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9993052406920615,
		"percent_rated_long": 0.9993052406920615,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"FOUSA00LA4": {
		"fund_id": "FSUSA002PV",
		"investment_vehicle_name": "Vanguard Value Index Adm",
		"ticker": "VVIAX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9983908498675275,
		"percent_rated_long": 0.9983908498675275,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FOUSA00IJP": {
		"fund_id": "FSUSA002PV",
		"investment_vehicle_name": "Vanguard Value Index I",
		"ticker": "VIVIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Value Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9983908498675275,
		"percent_rated_long": 0.9983908498675275,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 5
	},
	"FOUSA00FR3": {
		"fund_id": "FSUSA002Q0",
		"investment_vehicle_name": "Vanguard Institutional Index I",
		"ticker": "VINIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Institutional Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9990916525839374,
		"percent_rated_long": 0.9990916525839374,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"FOUSA00GPG": {
		"fund_id": "FSUSA002Q0",
		"investment_vehicle_name": "Vanguard Institutional Index Instl Pl",
		"ticker": "VIIIX",
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "Vanguard Institutional Index Fund",
		"fund_family_label": "Vanguard",
		"sustainable_investment": 0,
		"percent_rated": 0.9990916525839374,
		"percent_rated_long": 0.9990916525839374,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"STSP0LINCM": {
		"fund_id": "FTSP0LINCM",
		"investment_vehicle_name": "L Income",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L Income",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.2599004050514833,
		"percent_rated_long": 0.2604878701227155,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"STSP00000C": {
		"fund_id": "FTSP00000C",
		"investment_vehicle_name": "TSP C Fund - Common Stock Index Investment Fund",
		"ticker": null,
		"portfolio_date": "2025-03-31",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "TSP C Fund - Common Stock Index Investment Fund",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9929029056493632,
		"percent_rated_long": 0.9952476436244428,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 5,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 4,
		"grade_tobacco": 4
	},
	"STSP00000S": {
		"fund_id": "FTSP00000S",
		"investment_vehicle_name": "TSP S Fund - Small cap stock Index investment fund",
		"ticker": null,
		"portfolio_date": "2025-02-28",
		"type": "equity",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "TSP S Fund - Small cap stock Index investment fund",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9959704562290839,
		"percent_rated_long": 0.9966077345363364,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STSP0L2040": {
		"fund_id": "FTSP0L2040",
		"investment_vehicle_name": "L 2040",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2040",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.7071312061900712,
		"percent_rated_long": 0.7103574288338476,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STSP0L2030": {
		"fund_id": "FTSP0L2030",
		"investment_vehicle_name": "L 2030",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2030",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.5934253791027706,
		"percent_rated_long": 0.5956758567441461,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 3,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STSP0L2035": {
		"fund_id": "FTSP0L2035",
		"investment_vehicle_name": "L 2035",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2035",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.6503026579057529,
		"percent_rated_long": 0.6530535625058586,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STSP0L2045": {
		"fund_id": "FTSP0L2045",
		"investment_vehicle_name": "L 2045",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2045",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.7559662838472346,
		"percent_rated_long": 0.7596362852927827,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"STSP0L2025": {
		"fund_id": "FTSP0L2025",
		"investment_vehicle_name": "L 2025",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2025",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.30085777386051493,
		"percent_rated_long": 0.30160368508831376,
		"grade_fossil": 0,
		"grade_fossil_bank": 0,
		"grade_fossil_insure": 0,
		"grade_deforestation": 0,
		"grade_gender_equality": 0,
		"grade_guns": 0,
		"grade_military": 0,
		"grade_prison_industrial_complex": 0,
		"grade_tobacco": 0
	},
	"STSP00000I": {
		"fund_id": "FTSP00000I",
		"investment_vehicle_name": "TSP I Fund - International Stock Index Investment Fund",
		"ticker": null,
		"portfolio_date": "2025-03-31",
		"type": "equity",
		"category_group": "International Equity Funds",
		"fund_legal_name": "TSP I Fund - International Stock Index Investment Fund",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9690280435729319,
		"percent_rated_long": 0.9789673651984627,
		"grade_fossil": 5,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_military": 5,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"STSP0L2055": {
		"fund_id": "FTSP0L2055",
		"investment_vehicle_name": "L 2055",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2055",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9754202286616774,
		"percent_rated_long": 0.9800065478969623,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"STSP0L2060": {
		"fund_id": "FTSP0L2060",
		"investment_vehicle_name": "L 2060",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2060",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9754202026816235,
		"percent_rated_long": 0.9800065347844927,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"STSP0L2065": {
		"fund_id": "FTSP0L2065",
		"investment_vehicle_name": "L 2065",
		"ticker": null,
		"portfolio_date": "2024-10-01",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "L 2065",
		"fund_family_label": "Thrift Savings Plan",
		"sustainable_investment": 0,
		"percent_rated": 0.9754201680415535,
		"percent_rated_long": 0.9800065173012004,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 4
	},
	"STIAA00003": {
		"fund_id": "FTIAA00001",
		"investment_vehicle_name": "CREF Equity Index Account (R3)",
		"ticker": "QCEQIX",
		"portfolio_date": "2024-10-31",
		"type": "default",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "CREF Equity Index Account",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9757233589450778,
		"percent_rated_long": 0.9757233589450778,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STIAA00007": {
		"fund_id": "FTIAA00002",
		"investment_vehicle_name": "CREF Stock Account (R3)",
		"ticker": "QCSTIX",
		"portfolio_date": "2024-10-31",
		"type": "default",
		"category_group": "Allocation Funds",
		"fund_legal_name": "CREF Stock Account",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.974075421930943,
		"percent_rated_long": 0.9741064262353981,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"STIAA00011": {
		"fund_id": "FTIAA00003",
		"investment_vehicle_name": "CREF Growth Account (R3)",
		"ticker": "QCGRIX",
		"portfolio_date": "2024-10-31",
		"type": "default",
		"category_group": "U.S. Equity Fund",
		"fund_legal_name": "CREF Growth Account",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9817765422363708,
		"percent_rated_long": 0.9817930069704588,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_military": 3,
		"grade_prison_industrial_complex": 3,
		"grade_tobacco": 1
	},
	"STIAA00015": {
		"fund_id": "FTIAA00004",
		"investment_vehicle_name": "CREF Global Equities Account (R3)",
		"ticker": "QCGLIX",
		"portfolio_date": "2024-10-31",
		"type": "default",
		"category_group": "International Equity Funds",
		"fund_legal_name": "CREF Global Equities Account",
		"fund_family_label": "TIAA Investments/Nuveen",
		"sustainable_investment": 0,
		"percent_rated": 0.9742083339820078,
		"percent_rated_long": 0.9742107510403487,
		"grade_fossil": 5,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_military": 4,
		"grade_prison_industrial_complex": 5,
		"grade_tobacco": 3
	},
	"F00000WUF1": {
		"investment_vehicle_name": "iShares MSCI Global Sust Dev Goals ETF",
		"fund_id": "FS0000CCWW",
		"ticker": "SDG",
		"fund_legal_name": "iShares MSCI Global Sustainable Development Goals ETF",
		"category_group": "International Equity Funds",
		"morningstar_category_name": "Global Large-Stock Blend",
		"strategy_name": "BlackRock MSCI Sustainable Impact",
		"fund_family_label": "BlackRock/iShares",
		"portfolio_date": "2025-03-31",
		"net_assets": 173765432,
		"percent_rated": 0.9777709176360839,
		"percent_rated_long": 0.9848957433216431,
		"sustainable_investment": 1,
		"ff_all_weight": 0.005251246364271586,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.07088738409917301,
		"df_f_weight": 0,
		"df_c_weight": 0.1631419432488018,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 52.461473241760224,
		"gef_grp_norm": 25.868372943327238,
		"gef_percent_rated": 0.6817500063313766,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 1,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000ZAXE": {
		"investment_vehicle_name": "AXS Change Finance ESG ETF",
		"fund_id": "FS0000DDB3",
		"ticker": "CHGX",
		"fund_legal_name": "AXS Change Finance ESG ETF",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Change AXS Change Finance ESG",
		"fund_family_label": "AXS",
		"portfolio_date": "2025-03-31",
		"net_assets": 125287051,
		"percent_rated": 0.9965670674138543,
		"percent_rated_long": 0.9965670674138543,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.04807277329881442,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0.019996216528394464,
		"t_all_weight": 0.019996216528394464,
		"pff_all_weight": 0.040098828728916285,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 52.504369710433686,
		"gef_grp_norm": 51.87940485512921,
		"gef_percent_rated": 0.9965670674138543,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 1,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"FOUSA00BJQ": {
		"investment_vehicle_name": "Calvert Equity A",
		"fund_id": "FSUSA000AZ",
		"ticker": "CSIEX",
		"fund_legal_name": "Calvert Equity Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Growth",
		"strategy_name": "Atlanta High Quality Calvert Equity",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 6358224580,
		"percent_rated": 0.9688057519037807,
		"percent_rated_long": 0.9688057519037807,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.08509655741037069,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.0317524363066773,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.0317524363066773,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.1656311509210642,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 57.387252194470484,
		"gef_grp_norm": 96.28034455755677,
		"gef_percent_rated": 0.9687698313418177,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 4,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000VCX5": {
		"investment_vehicle_name": "Calvert US Large Cap Growth Rspnb Idx I",
		"fund_id": "FS0000BOXA",
		"ticker": "CGJIX",
		"fund_legal_name": "Calvert US Large-Cap Growth Responsible Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Growth",
		"strategy_name": "Calvert US Large Cap Growth Rspnb Index",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 737024420,
		"percent_rated": 0.9994092231028112,
		"percent_rated_long": 0.9994092231028112,
		"sustainable_investment": 1,
		"ff_all_weight": 0.009674003746035987,
		"c2_weight": 0.0005846563401522029,
		"mc50_weight": 0,
		"df_p_weight": 0.0007301861178493923,
		"df_f_weight": 0,
		"df_c_weight": 0.10127558460003265,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.0018214647487528296,
		"wff_civ_weight": 0.0018214647487528296,
		"wff_major_military_contractors_weight": 0.030772809400263834,
		"wff_cluster_munitions_weight": 0.0030956260580890928,
		"wff_nuclear_weapons_weight": 0.01348425877123583,
		"wff_mil_weight": 0.030772809400263834,
		"t_weight": 0,
		"t_m_weight": 0.006208122656234376,
		"t_all_weight": 0.006208122656234376,
		"pff_all_weight": 0.214804506748908,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.005094478416332528,
		"gef_score": 53.38292120681289,
		"gef_grp_norm": 57.948316366483944,
		"gef_percent_rated": 0.9983719331850632,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00000VCX9": {
		"investment_vehicle_name": "Calvert US Large Cap Value Rspnb Idx I",
		"fund_id": "FS0000BOXB",
		"ticker": "CFJIX",
		"fund_legal_name": "Calvert US Large-Cap Value Responsible Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Value",
		"strategy_name": "Calvert US Large Cap Value Resp Index",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 1836725067,
		"percent_rated": 0.9993539158247902,
		"percent_rated_long": 0.9993539158247902,
		"sustainable_investment": 1,
		"ff_all_weight": 0.07736622565515408,
		"c2_weight": 0.003389942301037916,
		"mc50_weight": 0.003192977602020172,
		"df_p_weight": 0.0020469067840080827,
		"df_f_weight": 0.07578013470864227,
		"df_c_weight": 0.1161073487978917,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.02406594693684768,
		"wff_civ_weight": 0.02406594693684768,
		"wff_major_military_contractors_weight": 0.02070336910145736,
		"wff_cluster_munitions_weight": 0.0008699984710340973,
		"wff_nuclear_weapons_weight": 0.007621241334101093,
		"wff_mil_weight": 0.02070336910145736,
		"t_weight": 0,
		"t_m_weight": 0.02077761973507165,
		"t_all_weight": 0.02077761973507165,
		"pff_all_weight": 0.08344938594993324,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.008191750235420509,
		"gef_score": 54.51687603412964,
		"gef_grp_norm": 70.43852779953015,
		"gef_percent_rated": 0.9954710423734855,
		"fossil_bank_score": 46.5265,
		"fossil_insure_score": 11.5199,
		"grade_fossil": 4,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F000014VXA": {
		"investment_vehicle_name": "Northern World Selection Index K",
		"fund_id": "FSUSA08GBJ",
		"ticker": "NSRKX",
		"fund_legal_name": "Northern World Selection Index Fund",
		"category_group": "International Equity Funds",
		"morningstar_category_name": "Global Large-Stock Blend",
		"strategy_name": "NT MSCI World ESG Index",
		"fund_family_label": "Northern Funds",
		"portfolio_date": "2024-12-31",
		"net_assets": 1993068871,
		"percent_rated": 0.9883548881136481,
		"percent_rated_long": 0.9883548881136481,
		"sustainable_investment": 1,
		"ff_all_weight": 0.04306685396021119,
		"c2_weight": 0.006406129856212079,
		"mc50_weight": 0.0005123239918386142,
		"df_p_weight": 0.004219409134507525,
		"df_f_weight": 0.018554356318578016,
		"df_c_weight": 0.09502086142411081,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.0003465605278624614,
		"wff_civ_weight": 0.0003465605278624614,
		"wff_major_military_contractors_weight": 0.021117310903000903,
		"wff_cluster_munitions_weight": 0.002514127872302713,
		"wff_nuclear_weapons_weight": 0.010370872929056951,
		"wff_mil_weight": 0.021117310903000903,
		"t_weight": 0,
		"t_m_weight": 0.012982859436772569,
		"t_all_weight": 0.012982859436772569,
		"pff_all_weight": 0.18134809702720003,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.003323802351434147,
		"gef_score": 56.18016629542738,
		"gef_grp_norm": 61.79159049360147,
		"gef_percent_rated": 0.9881745651929356,
		"fossil_bank_score": 11.3388,
		"fossil_insure_score": 9.9775,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00000N2G9": {
		"investment_vehicle_name": "Boston Trust Walden SMID Cap",
		"fund_id": "FS00008TLS",
		"ticker": "WASMX",
		"fund_legal_name": "Boston Trust Walden SMID Cap Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Mid-Cap Blend",
		"strategy_name": "Boston Trust Walden SMID Cap",
		"fund_family_label": "Boston Trust Walden Funds",
		"portfolio_date": "2025-02-28",
		"net_assets": 311151805,
		"percent_rated": 0.9879269959562021,
		"percent_rated_long": 0.9879269959562021,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.02731838884881288,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 44.93490714850809,
		"gef_grp_norm": 29.169929522317933,
		"gef_percent_rated": 0.9879269959562021,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1.5,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 1,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"FOUSA06M6P": {
		"investment_vehicle_name": "DFA US Sustainability Core 1",
		"fund_id": "FSUSA08HSM",
		"ticker": "DFSIX",
		"fund_legal_name": "DFA U.S. Sustainability Core 1 Portfolio",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "DFA US All Cap Core Sustainability Eq",
		"fund_family_label": "Dimensional Fund Advisors",
		"portfolio_date": "2025-02-28",
		"net_assets": 7640457517,
		"percent_rated": 0.9984317384170595,
		"percent_rated_long": 0.9984317384170595,
		"sustainable_investment": 1,
		"ff_all_weight": 0.026654866877653238,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.02582025952779079,
		"df_c_weight": 0.10311950328196556,
		"wff_gun_manufacturers_weight": 0.0009720737250975805,
		"wff_gun_retailers_weight": 0.009423107168622713,
		"wff_civ_weight": 0.010395180893720294,
		"wff_major_military_contractors_weight": 0.036312203998607746,
		"wff_cluster_munitions_weight": 0.010813740776146769,
		"wff_nuclear_weapons_weight": 0.020634782099005027,
		"wff_mil_weight": 0.036312203998607746,
		"t_weight": 0,
		"t_m_weight": 0.005630478659724481,
		"t_all_weight": 0.005630478659724481,
		"pff_all_weight": 0.1379947013191409,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.013645136926425239,
		"gef_score": 52.59810931403121,
		"gef_grp_norm": 52.54502740798747,
		"gef_percent_rated": 0.9711728692280615,
		"fossil_bank_score": 9.5567,
		"fossil_insure_score": 10.3232,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"FOUSA06MDL": {
		"investment_vehicle_name": "Nuveen Lifecycle 2050 R6",
		"fund_id": "FSUSA08I1X",
		"ticker": "TFTIX",
		"fund_legal_name": "Nuveen Lifecycle 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Nuveen Lifecycle Series",
		"fund_family_label": "TIAA Investments/Nuveen",
		"portfolio_date": "2025-02-28",
		"net_assets": 3487165850,
		"percent_rated": 0.8798919025953289,
		"percent_rated_long": 0.8815268114867045,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07285486896916057,
		"c2_weight": 0.03213595655030149,
		"mc50_weight": 0.006609955488221417,
		"df_p_weight": 0.0028084829471864163,
		"df_f_weight": 0.034921386853613616,
		"df_c_weight": 0.08123347429872034,
		"wff_gun_manufacturers_weight": 0.0012234902622449892,
		"wff_gun_retailers_weight": 0.0074364658458163785,
		"wff_civ_weight": 0.008659956108061367,
		"wff_major_military_contractors_weight": 0.0366828904750489,
		"wff_cluster_munitions_weight": 0.016951736800868776,
		"wff_nuclear_weapons_weight": 0.02128800257312165,
		"wff_mil_weight": 0.0366828904750489,
		"t_weight": 0.005963521402340811,
		"t_m_weight": 0.011784022593638763,
		"t_all_weight": 0.017747543995979574,
		"pff_all_weight": 0.11976378839109789,
		"pff_extreme_weight": 0.00027371071054250757,
		"pff_high_weight": 0.010737240261808917,
		"gef_score": 54.43371552860647,
		"gef_grp_norm": 71.74231332357247,
		"gef_percent_rated": 0.7698304128926007,
		"fossil_bank_score": 18.6074,
		"fossil_insure_score": 6.5416,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"type": "default"
	},
	"FOUSA007GA": {
		"investment_vehicle_name": "Calvert US Large Cap Core Rspnb Idx I",
		"fund_id": "FSUSA002Y7",
		"ticker": "CISIX",
		"fund_legal_name": "Calvert US Large-Cap Core Responsible Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Calvert US Lg Cap Core Responsible Index",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 5877631900,
		"percent_rated": 0.9973300497093055,
		"percent_rated_long": 0.9973300497093055,
		"sustainable_investment": 1,
		"ff_all_weight": 0.030106331769432514,
		"c2_weight": 0.001876426456716352,
		"mc50_weight": 0.0007392160778220902,
		"df_p_weight": 0.0010679763732737329,
		"df_f_weight": 0.02574202903043316,
		"df_c_weight": 0.11115247162722117,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.008550399864271868,
		"wff_civ_weight": 0.008550399864271868,
		"wff_major_military_contractors_weight": 0.0272030762933623,
		"wff_cluster_munitions_weight": 0.0025950417207991536,
		"wff_nuclear_weapons_weight": 0.011412514621747579,
		"wff_mil_weight": 0.0272030762933623,
		"t_weight": 0,
		"t_m_weight": 0.010745081535303359,
		"t_all_weight": 0.010745081535303359,
		"pff_all_weight": 0.19125271642138733,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.005375761962908905,
		"gef_score": 54.03983699759516,
		"gef_grp_norm": 64.64369616288175,
		"gef_percent_rated": 0.9959386468213499,
		"fossil_bank_score": 16.3065,
		"fossil_insure_score": 3.1222,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00000ZKH4": {
		"investment_vehicle_name": "Calvert US Large Cap Core Rspnb Idx R6",
		"fund_id": "FSUSA002Y7",
		"ticker": "CSXRX",
		"fund_legal_name": "Calvert US Large-Cap Core Responsible Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Calvert US Lg Cap Core Responsible Index",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 5877631900,
		"percent_rated": 0.9973300497093055,
		"percent_rated_long": 0.9973300497093055,
		"sustainable_investment": 1,
		"ff_all_weight": 0.030106331769432514,
		"c2_weight": 0.001876426456716352,
		"mc50_weight": 0.0007392160778220902,
		"df_p_weight": 0.0010679763732737329,
		"df_f_weight": 0.02574202903043316,
		"df_c_weight": 0.11115247162722117,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.008550399864271868,
		"wff_civ_weight": 0.008550399864271868,
		"wff_major_military_contractors_weight": 0.0272030762933623,
		"wff_cluster_munitions_weight": 0.0025950417207991536,
		"wff_nuclear_weapons_weight": 0.011412514621747579,
		"wff_mil_weight": 0.0272030762933623,
		"t_weight": 0,
		"t_m_weight": 0.010745081535303359,
		"t_all_weight": 0.010745081535303359,
		"pff_all_weight": 0.19125271642138733,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.005375761962908905,
		"gef_score": 54.03983699759516,
		"gef_grp_norm": 64.64369616288175,
		"gef_percent_rated": 0.9959386468213499,
		"fossil_bank_score": 16.3065,
		"fossil_insure_score": 3.1222,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F000011XK3": {
		"investment_vehicle_name": "Calvert Small-Cap R6",
		"fund_id": "FSUSA06531",
		"ticker": "CALRX",
		"fund_legal_name": "Calvert Small-Cap Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Small Blend",
		"strategy_name": "Calvert Small Cap Core",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 2808097416,
		"percent_rated": 0.9936645299772606,
		"percent_rated_long": 0.9936645299772606,
		"sustainable_investment": 1,
		"ff_all_weight": 0.02134378944921902,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.02056597918253987,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.05867428888371585,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.05867428888371585,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.02056597918253987,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.02056597918253987,
		"gef_score": 38.7478651551749,
		"gef_grp_norm": 6.460454189506656,
		"gef_percent_rated": 0.8965580832969222,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000W59B": {
		"investment_vehicle_name": "Calvert US Mid Cap Core Rspnb Idx I",
		"fund_id": "FS0000C13N",
		"ticker": "CMJIX",
		"fund_legal_name": "Calvert US Mid-Cap Core Responsible Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Mid-Cap Blend",
		"strategy_name": "Calvert US Mid Cap Core Resp Index",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 479087509,
		"percent_rated": 0.9970136478761754,
		"percent_rated_long": 0.9970136478761754,
		"sustainable_investment": 1,
		"ff_all_weight": 0.054375815504720246,
		"c2_weight": 0.000736568984519277,
		"mc50_weight": 0.0037838828313096345,
		"df_p_weight": 0.004056941505440084,
		"df_f_weight": 0,
		"df_c_weight": 0.05271468056580035,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.0012451253451485832,
		"wff_civ_weight": 0.0012451253451485832,
		"wff_major_military_contractors_weight": 0.026555943874545893,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.0102862627545566,
		"wff_mil_weight": 0.026555943874545893,
		"t_weight": 0,
		"t_m_weight": 0.0007502428956042768,
		"t_all_weight": 0.0007502428956042768,
		"pff_all_weight": 0.032853578321951196,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.016092634132942922,
		"gef_score": 48.282530928593694,
		"gef_grp_norm": 37.78386844166014,
		"gef_percent_rated": 0.9904211967254608,
		"fossil_bank_score": 0,
		"fossil_insure_score": 4.4829,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00001B6VM": {
		"investment_vehicle_name": "Sphere 500 Climate Fund",
		"fund_id": "FS0000H0U8",
		"ticker": "SPFFX",
		"fund_legal_name": "Sphere 500 Climate Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Reflection Asset Sphere 500 Fossil Free",
		"fund_family_label": "Reflection Asset Management",
		"portfolio_date": "2024-12-31",
		"net_assets": 27663864,
		"percent_rated": 0.9909055004029805,
		"percent_rated_long": 0.9909055004029805,
		"sustainable_investment": 1,
		"ff_all_weight": 0.003199878368401464,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.02980953781438486,
		"df_c_weight": 0.12875493459626608,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.005238205335306738,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.005238205335306738,
		"t_weight": 0,
		"t_m_weight": 0.0131364150720232,
		"t_all_weight": 0.0131364150720232,
		"pff_all_weight": 0.1903230148904723,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 54.93692575846821,
		"gef_grp_norm": 76.11589663273297,
		"gef_percent_rated": 0.9909055004029805,
		"fossil_bank_score": 17.8938,
		"fossil_insure_score": 5.5852,
		"grade_fossil": 2,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 2,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00001CRNE": {
		"investment_vehicle_name": "Natixis Target Retirement 2065 N",
		"fund_id": "FS0000H5P1",
		"ticker": "NSFOX",
		"fund_legal_name": "Natixis Target Retiremet 2065",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2065+",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 4856743,
		"percent_rated": 0.8961753532962614,
		"percent_rated_long": 0.8971548590189985,
		"sustainable_investment": 1,
		"ff_all_weight": 0.05302370373849984,
		"c2_weight": 0.02298370229869587,
		"mc50_weight": 0.0010296053383634749,
		"df_p_weight": 0.0015664392195074842,
		"df_f_weight": 0.02144089706850518,
		"df_c_weight": 0.06838439635545665,
		"wff_gun_manufacturers_weight": 0.00040085912993815674,
		"wff_gun_retailers_weight": 0.0026182333114996076,
		"wff_civ_weight": 0.0030190924414377645,
		"wff_major_military_contractors_weight": 0.0360071602934265,
		"wff_cluster_munitions_weight": 0.011351412319846052,
		"wff_nuclear_weapons_weight": 0.02330159893651384,
		"wff_mil_weight": 0.0360071602934265,
		"t_weight": 0,
		"t_m_weight": 0.00968481966296062,
		"t_all_weight": 0.00968481966296062,
		"pff_all_weight": 0.08944120485151152,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.006840062905258814,
		"gef_score": 53.813005847969684,
		"gef_grp_norm": 48.75549048316252,
		"gef_percent_rated": 0.8341631400236112,
		"fossil_bank_score": 16.6987,
		"fossil_insure_score": 8.0761,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"FOUSA07ZS1": {
		"investment_vehicle_name": "Calvert Global Water I",
		"fund_id": "FSUSA098CG",
		"ticker": "CFWIX",
		"fund_legal_name": "Calvert Global Water Fund",
		"category_group": "Sector Equity Funds",
		"morningstar_category_name": "Natural Resources",
		"strategy_name": "Calvert Global Water",
		"fund_family_label": "Calvert-OE",
		"portfolio_date": "2025-01-31",
		"net_assets": 530503553,
		"percent_rated": 0.9943336496372155,
		"percent_rated_long": 0.9943336496372155,
		"sustainable_investment": 1,
		"ff_all_weight": 0.04978528579242145,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.0057630886404261275,
		"df_f_weight": 0,
		"df_c_weight": 0.02866874672939278,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.005723002198252949,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.005723002198252949,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 50.99827770876743,
		"gef_grp_norm": 49.48096885813148,
		"gef_percent_rated": 0.7926454151382469,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 3,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 4,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 2,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"FOUSA05HGA": {
		"investment_vehicle_name": "Parnassus Core Equity Institutional",
		"fund_id": "FSUSA001WD",
		"ticker": "PRILX",
		"fund_legal_name": "Parnassus Core Equity Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Parnassus Core Equity Strategy",
		"fund_family_label": "Parnassus",
		"portfolio_date": "2025-02-28",
		"net_assets": 28413253810,
		"percent_rated": 0.9947656445124332,
		"percent_rated_long": 0.9947656445124332,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.02160224626522632,
		"df_c_weight": 0.09076999316045599,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.24293130998501436,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 55.81248551355742,
		"gef_grp_norm": 85.94361785434612,
		"gef_percent_rated": 0.9947656445124332,
		"fossil_bank_score": 16.7011,
		"fossil_insure_score": 0,
		"grade_fossil": 2,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 1,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000VEW8": {
		"investment_vehicle_name": "Parnassus Mid Cap Growth Institutional",
		"fund_id": "FSUSA001XC",
		"ticker": "PFPRX",
		"fund_legal_name": "Parnassus Mid Cap Growth Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Mid-Cap Growth",
		"strategy_name": "Parnassus Multi-Cap",
		"fund_family_label": "Parnassus",
		"portfolio_date": "2025-02-28",
		"net_assets": 819495598,
		"percent_rated": 0.9937062981026531,
		"percent_rated_long": 0.9937062981026531,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.04361890544285755,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 48.335233157029606,
		"gef_grp_norm": 37.9796397807361,
		"gef_percent_rated": 0.9866811609157662,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 1,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 1,
		"grade_gender_equality": 4,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 1,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"FOUSA06BX6": {
		"investment_vehicle_name": "Impax Sustainable Allocation Instl",
		"fund_id": "FSUSA001XO",
		"ticker": "PAXIX",
		"fund_legal_name": "Impax Sustainable Allocation Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Moderate Allocation",
		"strategy_name": "Pax Balanced",
		"fund_family_label": "Impax Asset Management",
		"portfolio_date": "2025-02-28",
		"net_assets": 2305623101,
		"percent_rated": 0.6069390648950295,
		"percent_rated_long": 0.6079526614741303,
		"sustainable_investment": 1,
		"ff_all_weight": 0.006699392529434612,
		"c2_weight": 0.00003869024782888828,
		"mc50_weight": 0.0000010501069835309371,
		"df_p_weight": 0.004679463463685453,
		"df_f_weight": 0.015144281797575414,
		"df_c_weight": 0.05137247552274094,
		"wff_gun_manufacturers_weight": 2.077020445396402e-7,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 2.077020445396402e-7,
		"wff_major_military_contractors_weight": 0.0013811210054007744,
		"wff_cluster_munitions_weight": 0.000015363318956434213,
		"wff_nuclear_weapons_weight": 0.0002046081493865033,
		"wff_mil_weight": 0.0013811210054007744,
		"t_weight": 0.000005536083711815918,
		"t_m_weight": 0.00992272892417255,
		"t_all_weight": 0.009928265007884365,
		"pff_all_weight": 0.08355188478359793,
		"pff_extreme_weight": 3.7004875467950454e-7,
		"pff_high_weight": 0.00668039539336675,
		"gef_score": 55.79146260703616,
		"gef_grp_norm": 93.70424597364568,
		"gef_percent_rated": 0.5933739225295787,
		"fossil_bank_score": 2.0191,
		"fossil_insure_score": 8.8328,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 3,
		"grade_tobacco": 3,
		"type": "default"
	},
	"FOUSA08PQ5": {
		"investment_vehicle_name": "Nuveen Winslow Large-Cap Growth ESG I",
		"fund_id": "FSUSA09Q6S",
		"ticker": "NVLIX",
		"fund_legal_name": "Nuveen Winslow Large-Cap Growth ESG Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Growth",
		"strategy_name": "Winslow Capital US Lrg Cap Gr ESG",
		"fund_family_label": "TIAA Investments/Nuveen",
		"portfolio_date": "2025-02-28",
		"net_assets": 903155228,
		"percent_rated": 0.9912967474955479,
		"percent_rated_long": 0.9912967474955479,
		"sustainable_investment": 1,
		"ff_all_weight": 0.01033789841495553,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.09768101680080182,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.030774854796057273,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.015026961677511321,
		"wff_mil_weight": 0.030774854796057273,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.24426489617795802,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 53.62953267591399,
		"gef_grp_norm": 60.02349256068912,
		"gef_percent_rated": 0.9552976202226003,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 2,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 4,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000VEWA": {
		"investment_vehicle_name": "Parnassus Value Equity Institutional",
		"fund_id": "FSUSA06P39",
		"ticker": "PFPWX",
		"fund_legal_name": "Parnassus Value Equity Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Value",
		"strategy_name": "Parnassus Value Equity",
		"fund_family_label": "Parnassus",
		"portfolio_date": "2025-02-28",
		"net_assets": 4822923931,
		"percent_rated": 0.9959239970853274,
		"percent_rated_long": 0.9959239970853274,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.06316611071591874,
		"df_c_weight": 0.054123751221155224,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0.014289734813567807,
		"t_all_weight": 0.014289734813567807,
		"pff_all_weight": 0.08251737902021661,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.015850609732538202,
		"gef_score": 56.35473427269891,
		"gef_grp_norm": 90.8379013312451,
		"gef_percent_rated": 0.9780008622325501,
		"fossil_bank_score": 53.0287,
		"fossil_insure_score": 0,
		"grade_fossil": 2,
		"grade_fossil_bank": 5,
		"grade_fossil_insure": 1,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 4,
		"grade_military": 1,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00000P7YY": {
		"investment_vehicle_name": "Shelton Sustainable Equity Investor",
		"fund_id": "FS00009VYQ",
		"ticker": "NEXTX",
		"fund_legal_name": "Shelton Sustainable Equity Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Mid-Cap Growth",
		"strategy_name": "Shelton Green Alpha Stock",
		"fund_family_label": "Shelton Capital Management",
		"portfolio_date": "2024-12-31",
		"net_assets": 90837439,
		"percent_rated": 0.9445631961658506,
		"percent_rated_long": 0.9461104441011455,
		"sustainable_investment": 1,
		"ff_all_weight": 0.06671017496225813,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.03418529873888956,
		"df_f_weight": 0,
		"df_c_weight": 0.06493986798917817,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.036973405279553624,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.0063668800023915645,
		"wff_mil_weight": 0.036973405279553624,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.06772797452984224,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.06772797452984224,
		"gef_score": 49.7726322025648,
		"gef_grp_norm": 42.24745497259201,
		"gef_percent_rated": 0.8044731700797745,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 4,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": 3,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000VQAG": {
		"investment_vehicle_name": "Fidelity Freedom Index 2050 Instl Prem",
		"fund_id": "FSUSA0A7L8",
		"ticker": "FFOPX",
		"fund_legal_name": "Fidelity Freedom Index 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Fidelity Freedom Index Series",
		"fund_family_label": "Fidelity Investments",
		"portfolio_date": "2025-02-28",
		"net_assets": 20779054656,
		"percent_rated": 0.8690935266632863,
		"percent_rated_long": 0.8776320355477317,
		"sustainable_investment": 0,
		"ff_all_weight": 0.08232645387630388,
		"c2_weight": 0.029299354148549814,
		"mc50_weight": 0.01151487382746484,
		"df_p_weight": 0.0049421612978727165,
		"df_f_weight": 0.033296062412462704,
		"df_c_weight": 0.08182562238906449,
		"wff_gun_manufacturers_weight": 0.0006186815699101979,
		"wff_gun_retailers_weight": 0.004039592777742263,
		"wff_civ_weight": 0.004658274347652461,
		"wff_major_military_contractors_weight": 0.031143817687781874,
		"wff_cluster_munitions_weight": 0.012152868365501302,
		"wff_nuclear_weapons_weight": 0.019178451151765065,
		"wff_mil_weight": 0.031143817687781874,
		"t_weight": 0.0051518472256197635,
		"t_m_weight": 0.007024166900142776,
		"t_all_weight": 0.01217601412576254,
		"pff_all_weight": 0.11015233622942054,
		"pff_extreme_weight": 0.00013672561142618605,
		"pff_high_weight": 0.010004435076798915,
		"gef_score": 54.50111361060004,
		"gef_grp_norm": 74.81698389458272,
		"gef_percent_rated": 0.7689783947702037,
		"fossil_bank_score": 17.4572,
		"fossil_insure_score": 16.5655,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"type": "default"
	},
	"F0000154LW": {
		"investment_vehicle_name": "Fidelity Freedom Index 2050 Premier",
		"fund_id": "FSUSA0A7L8",
		"ticker": "FRLPX",
		"fund_legal_name": "Fidelity Freedom Index 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Fidelity Freedom Index Series",
		"fund_family_label": "Fidelity Investments",
		"portfolio_date": "2025-02-28",
		"net_assets": 20779054656,
		"percent_rated": 0.8690935266632863,
		"percent_rated_long": 0.8776320355477317,
		"sustainable_investment": 0,
		"ff_all_weight": 0.08232645387630388,
		"c2_weight": 0.029299354148549814,
		"mc50_weight": 0.01151487382746484,
		"df_p_weight": 0.0049421612978727165,
		"df_f_weight": 0.033296062412462704,
		"df_c_weight": 0.08182562238906449,
		"wff_gun_manufacturers_weight": 0.0006186815699101979,
		"wff_gun_retailers_weight": 0.004039592777742263,
		"wff_civ_weight": 0.004658274347652461,
		"wff_major_military_contractors_weight": 0.031143817687781874,
		"wff_cluster_munitions_weight": 0.012152868365501302,
		"wff_nuclear_weapons_weight": 0.019178451151765065,
		"wff_mil_weight": 0.031143817687781874,
		"t_weight": 0.0051518472256197635,
		"t_m_weight": 0.007024166900142776,
		"t_all_weight": 0.01217601412576254,
		"pff_all_weight": 0.11015233622942054,
		"pff_extreme_weight": 0.00013672561142618605,
		"pff_high_weight": 0.010004435076798915,
		"gef_score": 54.50111361060004,
		"gef_grp_norm": 74.81698389458272,
		"gef_percent_rated": 0.7689783947702037,
		"fossil_bank_score": 17.4572,
		"fossil_insure_score": 16.5655,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"type": "default"
	},
	"FOUSA02SNF": {
		"investment_vehicle_name": "Vanguard FTSE Social Index I",
		"fund_id": "FSUSA003PD",
		"ticker": "VFTNX",
		"fund_legal_name": "Vanguard FTSE Social Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Vanguard FTSE Social Index",
		"fund_family_label": "Vanguard",
		"portfolio_date": "2025-02-28",
		"net_assets": 22607852665,
		"percent_rated": 0.9997335656921199,
		"percent_rated_long": 0.9998732466719794,
		"sustainable_investment": 1,
		"ff_all_weight": 0.005893842830762465,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.0020392722066787596,
		"df_f_weight": 0.031499435903063824,
		"df_c_weight": 0.11845495228365131,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.004550983553983001,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.004550983553983001,
		"t_weight": 0,
		"t_m_weight": 0.012531407442872625,
		"t_all_weight": 0.012531407442872625,
		"pff_all_weight": 0.21083938851514028,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.00751198368474075,
		"gef_score": 54.99555688451207,
		"gef_grp_norm": 78.34768989819891,
		"gef_percent_rated": 0.9987241996859536,
		"fossil_bank_score": 13.3544,
		"fossil_insure_score": 5.7702,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 2,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F000011IZ5": {
		"investment_vehicle_name": "Vanguard FTSE Social Index Admiral",
		"fund_id": "FSUSA003PD",
		"ticker": "VFTAX",
		"fund_legal_name": "Vanguard FTSE Social Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Vanguard FTSE Social Index",
		"fund_family_label": "Vanguard",
		"portfolio_date": "2025-02-28",
		"net_assets": 22607852665,
		"percent_rated": 0.9997335656921199,
		"percent_rated_long": 0.9998732466719794,
		"sustainable_investment": 1,
		"ff_all_weight": 0.005893842830762465,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.0020392722066787596,
		"df_f_weight": 0.031499435903063824,
		"df_c_weight": 0.11845495228365131,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.004550983553983001,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.004550983553983001,
		"t_weight": 0,
		"t_m_weight": 0.012531407442872625,
		"t_all_weight": 0.012531407442872625,
		"pff_all_weight": 0.21083938851514028,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.00751198368474075,
		"gef_score": 54.99555688451207,
		"gef_grp_norm": 78.34768989819891,
		"gef_percent_rated": 0.9987241996859536,
		"fossil_bank_score": 13.3544,
		"fossil_insure_score": 5.7702,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 2,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F00000YBQD": {
		"investment_vehicle_name": "Natixis Target Retirement 2060 N",
		"fund_id": "FS0000D06X",
		"ticker": "NSFMX",
		"fund_legal_name": "Natixis Target Retiremet 2060",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2060",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 18610698,
		"percent_rated": 0.8986373058297221,
		"percent_rated_long": 0.8996169889620461,
		"sustainable_investment": 1,
		"ff_all_weight": 0.05375272995677179,
		"c2_weight": 0.023378308506935615,
		"mc50_weight": 0.0010514191524476357,
		"df_p_weight": 0.0015661732230458107,
		"df_f_weight": 0.02176906955829475,
		"df_c_weight": 0.06927069164818919,
		"wff_gun_manufacturers_weight": 0.0003400245204326802,
		"wff_gun_retailers_weight": 0.0025555781359686194,
		"wff_civ_weight": 0.0028956026564012994,
		"wff_major_military_contractors_weight": 0.03535912542246484,
		"wff_cluster_munitions_weight": 0.011135884794297472,
		"wff_nuclear_weapons_weight": 0.022724925425576366,
		"wff_mil_weight": 0.03535912542246484,
		"t_weight": 0,
		"t_m_weight": 0.009688036901164335,
		"t_all_weight": 0.009688036901164335,
		"pff_all_weight": 0.0897504080313892,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.006883683385790691,
		"gef_score": 53.80525863010991,
		"gef_grp_norm": 48.46266471449488,
		"gef_percent_rated": 0.8370972299492703,
		"fossil_bank_score": 16.8463,
		"fossil_insure_score": 8.1041,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBQJ": {
		"investment_vehicle_name": "Natixis Target Retirement 2030 N",
		"fund_id": "FS0000D070",
		"ticker": "NSFFX",
		"fund_legal_name": "Natixis Target Retiremet 2030",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2030",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 17635768,
		"percent_rated": 0.5707597702288064,
		"percent_rated_long": 0.5718127465371058,
		"sustainable_investment": 1,
		"ff_all_weight": 0.03442274627263489,
		"c2_weight": 0.015094751719506787,
		"mc50_weight": 0.0006998384311894899,
		"df_p_weight": 0.0009354001096180082,
		"df_f_weight": 0.014123334913063283,
		"df_c_weight": 0.04451140595582093,
		"wff_gun_manufacturers_weight": 0.0002206203157926916,
		"wff_gun_retailers_weight": 0.0017304941393949578,
		"wff_civ_weight": 0.0019511144551876494,
		"wff_major_military_contractors_weight": 0.02222457129036323,
		"wff_cluster_munitions_weight": 0.006897469994020056,
		"wff_nuclear_weapons_weight": 0.014342370580354698,
		"wff_mil_weight": 0.02222457129036323,
		"t_weight": 0,
		"t_m_weight": 0.006287510227559897,
		"t_all_weight": 0.006287510227559897,
		"pff_all_weight": 0.05843199781933767,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.004253331776728033,
		"gef_score": 53.75828850618096,
		"gef_grp_norm": 46.412884333821374,
		"gef_percent_rated": 0.5358125107542049,
		"fossil_bank_score": 10.8337,
		"fossil_insure_score": 5.0804,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBQM": {
		"investment_vehicle_name": "Natixis Target Retirement 2035 N",
		"fund_id": "FS0000D071",
		"ticker": "NSFGX",
		"fund_legal_name": "Natixis Target Retiremet 2035",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2035",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 20267498,
		"percent_rated": 0.6543662979412782,
		"percent_rated_long": 0.6554033603367914,
		"sustainable_investment": 1,
		"ff_all_weight": 0.0390726581419143,
		"c2_weight": 0.01714720177630311,
		"mc50_weight": 0.0007977962352594217,
		"df_p_weight": 0.0010784327157391945,
		"df_f_weight": 0.016066684194044317,
		"df_c_weight": 0.050659107864960265,
		"wff_gun_manufacturers_weight": 0.0002880342443693633,
		"wff_gun_retailers_weight": 0.0019365832417732871,
		"wff_civ_weight": 0.0022246174861426504,
		"wff_major_military_contractors_weight": 0.02566591467614591,
		"wff_cluster_munitions_weight": 0.007935164671778626,
		"wff_nuclear_weapons_weight": 0.016708759050592284,
		"wff_mil_weight": 0.02566591467614591,
		"t_weight": 0,
		"t_m_weight": 0.007264747823182473,
		"t_all_weight": 0.007264747823182473,
		"pff_all_weight": 0.06683981278838456,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.00482581908032854,
		"gef_score": 53.77963815541453,
		"gef_grp_norm": 47.73060029282577,
		"gef_percent_rated": 0.6142754477723052,
		"fossil_bank_score": 12.3814,
		"fossil_insure_score": 5.8326,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBT8": {
		"investment_vehicle_name": "Natixis Target Retirement 2040 N",
		"fund_id": "FS0000D086",
		"ticker": "NSFHX",
		"fund_legal_name": "Natixis Target Retiremet 2040",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2040",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 28493047,
		"percent_rated": 0.7406272240903735,
		"percent_rated_long": 0.7416253035309525,
		"sustainable_investment": 1,
		"ff_all_weight": 0.04452141074500615,
		"c2_weight": 0.019635372824655363,
		"mc50_weight": 0.0008820427647501338,
		"df_p_weight": 0.0011874180649454372,
		"df_f_weight": 0.018077133055269572,
		"df_c_weight": 0.057830422900900125,
		"wff_gun_manufacturers_weight": 0.00029034579445244015,
		"wff_gun_retailers_weight": 0.0021914378075976364,
		"wff_civ_weight": 0.0024817836020500765,
		"wff_major_military_contractors_weight": 0.0287019496450483,
		"wff_cluster_munitions_weight": 0.008798230706911865,
		"wff_nuclear_weapons_weight": 0.018558752574394977,
		"wff_mil_weight": 0.0287019496450483,
		"t_weight": 0,
		"t_m_weight": 0.008199473233142698,
		"t_all_weight": 0.008199473233142698,
		"pff_all_weight": 0.07657653950429368,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.005473192002773328,
		"gef_score": 53.74218023782269,
		"gef_grp_norm": 44.21669106881406,
		"gef_percent_rated": 0.6966587355779724,
		"fossil_bank_score": 14.0445,
		"fossil_insure_score": 6.6156,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBTA": {
		"investment_vehicle_name": "Natixis Target Retirement 2045 N",
		"fund_id": "FS0000D087",
		"ticker": "NSFJX",
		"fund_legal_name": "Natixis Target Retiremet 2045",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2045",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 26200329,
		"percent_rated": 0.8135071642073581,
		"percent_rated_long": 0.8145559419553368,
		"sustainable_investment": 1,
		"ff_all_weight": 0.04899874321949508,
		"c2_weight": 0.021392296976100067,
		"mc50_weight": 0.0009784955791944333,
		"df_p_weight": 0.0013153388874494207,
		"df_f_weight": 0.0200216121978306,
		"df_c_weight": 0.06273266976878811,
		"wff_gun_manufacturers_weight": 0.0003157716158179464,
		"wff_gun_retailers_weight": 0.002404118277358508,
		"wff_civ_weight": 0.0027198898931764543,
		"wff_major_military_contractors_weight": 0.03139874616143912,
		"wff_cluster_munitions_weight": 0.009711631822045064,
		"wff_nuclear_weapons_weight": 0.020233606564496402,
		"wff_mil_weight": 0.03139874616143912,
		"t_weight": 0,
		"t_m_weight": 0.009014261486443244,
		"t_all_weight": 0.009014261486443244,
		"pff_all_weight": 0.08333273987839293,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.00643412582595737,
		"gef_score": 53.72935018924866,
		"gef_grp_norm": 43.77745241581259,
		"gef_percent_rated": 0.761495654935129,
		"fossil_bank_score": 15.4436,
		"fossil_insure_score": 7.2884,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBTC": {
		"investment_vehicle_name": "Natixis Target Retirement 2050 N",
		"fund_id": "FS0000D088",
		"ticker": "NSFKX",
		"fund_legal_name": "Natixis Target Retiremet 2050",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 28019007,
		"percent_rated": 0.8597343693381494,
		"percent_rated_long": 0.8607221146991626,
		"sustainable_investment": 1,
		"ff_all_weight": 0.051860877569695256,
		"c2_weight": 0.022513118375761493,
		"mc50_weight": 0.0010265145206698003,
		"df_p_weight": 0.0014443163158356558,
		"df_f_weight": 0.02073309074013262,
		"df_c_weight": 0.0664393277279568,
		"wff_gun_manufacturers_weight": 0.0003300389453849977,
		"wff_gun_retailers_weight": 0.002540422912726907,
		"wff_civ_weight": 0.002870461858111905,
		"wff_major_military_contractors_weight": 0.03373706758230043,
		"wff_cluster_munitions_weight": 0.010520226671244847,
		"wff_nuclear_weapons_weight": 0.021751059019189098,
		"wff_mil_weight": 0.03373706758230043,
		"t_weight": 0,
		"t_m_weight": 0.009353107563108634,
		"t_all_weight": 0.009353107563108634,
		"pff_all_weight": 0.08699856328326959,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.0067425496335621945,
		"gef_score": 53.771376170660986,
		"gef_grp_norm": 47.2913616398243,
		"gef_percent_rated": 0.8032139902599101,
		"fossil_bank_score": 16.0865,
		"fossil_insure_score": 7.6671,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F00000YBTE": {
		"investment_vehicle_name": "Natixis Target Retirement 2055 N",
		"fund_id": "FS0000D089",
		"ticker": "NSFLX",
		"fund_legal_name": "Natixis Target Retiremet 2055",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2055",
		"strategy_name": "Natixis Target Retirement Series",
		"fund_family_label": "Natixis Funds",
		"portfolio_date": "2025-01-31",
		"net_assets": 22436127,
		"percent_rated": 0.8872933725155657,
		"percent_rated_long": 0.8884411701238424,
		"sustainable_investment": 1,
		"ff_all_weight": 0.053380753047640526,
		"c2_weight": 0.02315635466002627,
		"mc50_weight": 0.0010559448766316575,
		"df_p_weight": 0.0015445277520497495,
		"df_f_weight": 0.021411569655451722,
		"df_c_weight": 0.06839178005919287,
		"wff_gun_manufacturers_weight": 0.0003253478249431239,
		"wff_gun_retailers_weight": 0.0025860010795007225,
		"wff_civ_weight": 0.0029113489044438464,
		"wff_major_military_contractors_weight": 0.0349182756171617,
		"wff_cluster_munitions_weight": 0.010903531042844842,
		"wff_nuclear_weapons_weight": 0.02243699467679572,
		"wff_mil_weight": 0.0349182756171617,
		"t_weight": 0,
		"t_m_weight": 0.009533327094478152,
		"t_all_weight": 0.009533327094478152,
		"pff_all_weight": 0.08874269212855075,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.006677762305498645,
		"gef_score": 53.796473869150276,
		"gef_grp_norm": 48.31625183016106,
		"gef_percent_rated": 0.8277238102110333,
		"fossil_bank_score": 16.5857,
		"fossil_insure_score": 7.9322,
		"grade_fossil": 3,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "default"
	},
	"F000013KHK": {
		"investment_vehicle_name": "GMO Climate Change R6",
		"fund_id": "FS0000D0PF",
		"ticker": "GCCAX",
		"fund_legal_name": "GMO Climate Change Fund",
		"category_group": "International Equity Funds",
		"morningstar_category_name": "Global Small/Mid Stock",
		"strategy_name": "GMO Climate Change Strategy",
		"fund_family_label": "GMO",
		"portfolio_date": "2024-12-31",
		"net_assets": 569136789,
		"percent_rated": 0.9797658987751708,
		"percent_rated_long": 0.9896744362739311,
		"sustainable_investment": 1,
		"ff_all_weight": 0.1305715144753399,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.0361634846372546,
		"df_f_weight": 0,
		"df_c_weight": 0,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.010924313496155882,
		"wff_cluster_munitions_weight": 0.010924313496155882,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0.010924313496155882,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 49.09618224395502,
		"gef_grp_norm": 16.087751371115175,
		"gef_percent_rated": 0.7743195703217814,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"grade_fossil": 5,
		"grade_fossil_bank": 1,
		"grade_fossil_insure": 1,
		"grade_deforestation": 5,
		"grade_gender_equality": 5,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 3,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F00000YJ0A": {
		"investment_vehicle_name": "Fidelity U.S. Sustainability Index",
		"fund_id": "FS0000D38F",
		"ticker": "FITLX",
		"fund_legal_name": "Fidelity U.S. Sustainability Index Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Geode Fidelity Sustainability IndexPrem",
		"fund_family_label": "Fidelity Investments",
		"portfolio_date": "2025-02-28",
		"net_assets": 4396834657,
		"percent_rated": 0.6901492224788988,
		"percent_rated_long": 0.7689455604263218,
		"sustainable_investment": 1,
		"ff_all_weight": 0.021381514527235673,
		"c2_weight": 0,
		"mc50_weight": 0.0008280610923807373,
		"df_p_weight": 0.0013541358557812272,
		"df_f_weight": 0.004613159295161982,
		"df_c_weight": 0.07337419225771381,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0.0004551853805864316,
		"wff_civ_weight": 0.0004551853805864316,
		"wff_major_military_contractors_weight": 0.01895347731267132,
		"wff_cluster_munitions_weight": 0.0021187313052741627,
		"wff_nuclear_weapons_weight": 0.010926731176577201,
		"wff_mil_weight": 0.01895347731267132,
		"t_weight": 0,
		"t_m_weight": 0.010060824281943766,
		"t_all_weight": 0.010060824281943766,
		"pff_all_weight": 0.1685179598968187,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.0023927863366019916,
		"gef_score": 56.272136654304234,
		"gef_grp_norm": 90.3680501174628,
		"gef_percent_rated": 0.7685962249892834,
		"fossil_bank_score": 3.2895,
		"fossil_insure_score": 2.2711,
		"grade_fossil": 3,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"FOUSA05HZH": {
		"investment_vehicle_name": "Vanguard Target Retirement 2050 Fund",
		"fund_id": "FSUSA072BK",
		"ticker": "VFIFX",
		"fund_legal_name": "Vanguard Target Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Vanguard Target Retirement Series",
		"fund_family_label": "Vanguard",
		"portfolio_date": "2025-02-28",
		"net_assets": 78837570701,
		"percent_rated": 0.8484281221360352,
		"percent_rated_long": 0.8656446517157385,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07973897951802304,
		"c2_weight": 0.02711313004242359,
		"mc50_weight": 0.011635201235846996,
		"df_p_weight": 0.004801743398454491,
		"df_f_weight": 0.029989453947344927,
		"df_c_weight": 0.07795398775599417,
		"wff_gun_manufacturers_weight": 0.0007351685374214476,
		"wff_gun_retailers_weight": 0.004171233567172338,
		"wff_civ_weight": 0.004906402104593786,
		"wff_major_military_contractors_weight": 0.03019684421105244,
		"wff_cluster_munitions_weight": 0.011520792848765915,
		"wff_nuclear_weapons_weight": 0.018175612691185537,
		"wff_mil_weight": 0.03019684421105244,
		"t_weight": 0.004859894812912602,
		"t_m_weight": 0.006669514845404103,
		"t_all_weight": 0.011529409658316706,
		"pff_all_weight": 0.11033360188646038,
		"pff_extreme_weight": 0.00011308031297907471,
		"pff_high_weight": 0.009822392658065364,
		"gef_score": 54.055094777088804,
		"gef_grp_norm": 59.29721815519766,
		"gef_percent_rated": 0.7486078449852221,
		"fossil_bank_score": 15.6102,
		"fossil_insure_score": 15.7995,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"type": "default"
	},
	"FOUSA02VJF": {
		"investment_vehicle_name": "Nuveen Large Cap Responsible Eq R6",
		"fund_id": "FSUSA00I37",
		"ticker": "TISCX",
		"fund_legal_name": "Nuveen Large Cap Responsible Equity Fund",
		"category_group": "U.S. Equity Fund",
		"morningstar_category_name": "Large Blend",
		"strategy_name": "Nuveen Large Cap Responsible Equity",
		"fund_family_label": "TIAA Investments/Nuveen",
		"portfolio_date": "2025-01-31",
		"net_assets": 7062666990,
		"percent_rated": 0.9959386500820988,
		"percent_rated_long": 0.9959386500820988,
		"sustainable_investment": 1,
		"ff_all_weight": 0.030740016952151384,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.00019138634200279632,
		"df_f_weight": 0.038702588751108595,
		"df_c_weight": 0.09790659661273368,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.026861844862375424,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.008811476187128001,
		"wff_mil_weight": 0.026861844862375424,
		"t_weight": 0,
		"t_m_weight": 0.019963145820074975,
		"t_all_weight": 0.019963145820074975,
		"pff_all_weight": 0.10994719814759382,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.008177889893687314,
		"gef_score": 57.04414771152014,
		"gef_grp_norm": 94.47924823805795,
		"gef_percent_rated": 0.9959386500820988,
		"fossil_bank_score": 14.9109,
		"fossil_insure_score": 8.0593,
		"grade_fossil": 3,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"FOUSA00CZK": {
		"investment_vehicle_name": "Green Century Balanced",
		"fund_id": "FSUSA0014V",
		"ticker": "GCBLX",
		"fund_legal_name": "Green Century Balanced Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Moderate Allocation",
		"strategy_name": "Trillium Moderate Alloc 50/70 Eq",
		"fund_family_label": "Green Century",
		"portfolio_date": "2025-01-31",
		"net_assets": 398641127,
		"percent_rated": 0.6684084254056406,
		"percent_rated_long": 0.6684084254056406,
		"sustainable_investment": 1,
		"ff_all_weight": 0,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.011614456428124637,
		"df_c_weight": 0.0875960748525578,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.00852292392801709,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.00852292392801709,
		"wff_mil_weight": 0.00852292392801709,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.12043982356090419,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 56.529033451860165,
		"gef_grp_norm": 96.77891654465594,
		"gef_percent_rated": 0.6684084254056406,
		"fossil_bank_score": 12.5923,
		"fossil_insure_score": 7.442,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 1.5,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 3,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"FOUSA05GUH": {
		"investment_vehicle_name": "Impax Ellevate Global Women's Ldr Instl",
		"fund_id": "FSUSA002BA",
		"ticker": "PXWIX",
		"fund_legal_name": "Impax Ellevate Global Women’s Leadership Fund",
		"category_group": "International Equity Funds",
		"morningstar_category_name": "Global Large-Stock Blend",
		"strategy_name": "Pax Global Women's Index",
		"fund_family_label": "Impax Asset Management",
		"portfolio_date": "2025-02-28",
		"net_assets": 731135072,
		"percent_rated": 0.9941912393852749,
		"percent_rated_long": 0.9948644320965535,
		"sustainable_investment": 1,
		"ff_all_weight": 0.015358344598651343,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0.05826286804853419,
		"df_c_weight": 0.1263129636871142,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.006538306076417992,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0.006538306076417992,
		"wff_mil_weight": 0.006538306076417992,
		"t_weight": 0,
		"t_m_weight": 0.012766035971508558,
		"t_all_weight": 0.012766035971508558,
		"pff_all_weight": 0.1263985137043457,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.006538306076417992,
		"gef_score": 61.790151618928,
		"gef_grp_norm": 97.53199268738574,
		"gef_percent_rated": 0.9948644320965535,
		"fossil_bank_score": 21.4044,
		"fossil_insure_score": 5.4516,
		"grade_fossil": 2,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 2,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 3,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "equity"
	},
	"F000010OFI": {
		"investment_vehicle_name": "Fidelity Freedom Blend 2050 K",
		"fund_id": "FS0000DV7F",
		"ticker": "FHWDX",
		"fund_legal_name": "Fidelity Freedom Blend 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Fidelity Freedom Blend Series",
		"fund_family_label": "Fidelity Investments",
		"portfolio_date": "2025-02-28",
		"net_assets": 2587859382,
		"percent_rated": 0.8015146557085607,
		"percent_rated_long": 0.8516088669674494,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07651959479793415,
		"c2_weight": 0.03086265097965348,
		"mc50_weight": 0.008243789649936897,
		"df_p_weight": 0.0031884898378857483,
		"df_f_weight": 0.025420066703158738,
		"df_c_weight": 0.0649812125065872,
		"wff_gun_manufacturers_weight": 0.0006786812620613787,
		"wff_gun_retailers_weight": 0.0034231510200965487,
		"wff_civ_weight": 0.004101832282157927,
		"wff_major_military_contractors_weight": 0.049342739710280824,
		"wff_cluster_munitions_weight": 0.024217734507716054,
		"wff_nuclear_weapons_weight": 0.03158283047955906,
		"wff_mil_weight": 0.049342739710280824,
		"t_weight": 0.004081792773642231,
		"t_m_weight": 0.006572164446555165,
		"t_all_weight": 0.010653957220197397,
		"pff_all_weight": 0.08470869550151007,
		"pff_extreme_weight": 0.000009597043110764285,
		"pff_high_weight": 0.008420399267497077,
		"gef_score": 53.71095070684527,
		"gef_grp_norm": 42.16691068814056,
		"gef_percent_rated": 0.7168014175195807,
		"fossil_bank_score": 19.861,
		"fossil_insure_score": 18.2018,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"type": "default"
	},
	"F000010OFJ": {
		"investment_vehicle_name": "Fidelity Freedom Blend 2050 K6",
		"fund_id": "FS0000DV7F",
		"ticker": "FHEDX",
		"fund_legal_name": "Fidelity Freedom Blend 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Fidelity Freedom Blend Series",
		"fund_family_label": "Fidelity Investments",
		"portfolio_date": "2025-02-28",
		"net_assets": 2587859382,
		"percent_rated": 0.8015146557085607,
		"percent_rated_long": 0.8516088669674494,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07651959479793415,
		"c2_weight": 0.03086265097965348,
		"mc50_weight": 0.008243789649936897,
		"df_p_weight": 0.0031884898378857483,
		"df_f_weight": 0.025420066703158738,
		"df_c_weight": 0.0649812125065872,
		"wff_gun_manufacturers_weight": 0.0006786812620613787,
		"wff_gun_retailers_weight": 0.0034231510200965487,
		"wff_civ_weight": 0.004101832282157927,
		"wff_major_military_contractors_weight": 0.049342739710280824,
		"wff_cluster_munitions_weight": 0.024217734507716054,
		"wff_nuclear_weapons_weight": 0.03158283047955906,
		"wff_mil_weight": 0.049342739710280824,
		"t_weight": 0.004081792773642231,
		"t_m_weight": 0.006572164446555165,
		"t_all_weight": 0.010653957220197397,
		"pff_all_weight": 0.08470869550151007,
		"pff_extreme_weight": 0.000009597043110764285,
		"pff_high_weight": 0.008420399267497077,
		"gef_score": 53.71095070684527,
		"gef_grp_norm": 42.16691068814056,
		"gef_percent_rated": 0.7168014175195807,
		"fossil_bank_score": 19.861,
		"fossil_insure_score": 18.2018,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"type": "default"
	},
	"F00001GGK0": {
		"investment_vehicle_name": "T. Rowe Price Retirement 2050 I",
		"fund_id": "FSUSA07VNR",
		"ticker": "TRJLX",
		"fund_legal_name": "T. Rowe Price Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "T. Rowe Price Retirement Series",
		"fund_family_label": "T. Rowe Price",
		"portfolio_date": "2025-02-28",
		"net_assets": 16176189402,
		"percent_rated": 0.9455360982631977,
		"percent_rated_long": 0.9498581641554301,
		"sustainable_investment": 0,
		"ff_all_weight": 0.09940599349515815,
		"c2_weight": 0.03547856748463019,
		"mc50_weight": 0.009335520611889166,
		"df_p_weight": 0.006752836246614828,
		"df_f_weight": 0.02730123667048142,
		"df_c_weight": 0.07197660274289731,
		"wff_gun_manufacturers_weight": 0.001056739573778828,
		"wff_gun_retailers_weight": 0.0031800941049025867,
		"wff_civ_weight": 0.004236833678681415,
		"wff_major_military_contractors_weight": 0.044728902597009734,
		"wff_cluster_munitions_weight": 0.00915948605219932,
		"wff_nuclear_weapons_weight": 0.02238640675339141,
		"wff_mil_weight": 0.044728902597009734,
		"t_weight": 0.002156948228905572,
		"t_m_weight": 0.0036814409076013723,
		"t_all_weight": 0.005838389136506945,
		"pff_all_weight": 0.10964482164511313,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.008736533039582937,
		"gef_score": 53.37283414905435,
		"gef_grp_norm": 31.91800878477306,
		"gef_percent_rated": 0.8579700044133386,
		"fossil_bank_score": 10.1948,
		"fossil_insure_score": 14.8124,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 3,
		"type": "default"
	},
	"FOUSA068A3": {
		"investment_vehicle_name": "T. Rowe Price Retirement 2050 R",
		"fund_id": "FSUSA07VNR",
		"ticker": "RRTFX",
		"fund_legal_name": "T. Rowe Price Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "T. Rowe Price Retirement Series",
		"fund_family_label": "T. Rowe Price",
		"portfolio_date": "2025-02-28",
		"net_assets": 16176189402,
		"percent_rated": 0.9455360982631977,
		"percent_rated_long": 0.9498581641554301,
		"sustainable_investment": 0,
		"ff_all_weight": 0.09940599349515815,
		"c2_weight": 0.03547856748463019,
		"mc50_weight": 0.009335520611889166,
		"df_p_weight": 0.006752836246614828,
		"df_f_weight": 0.02730123667048142,
		"df_c_weight": 0.07197660274289731,
		"wff_gun_manufacturers_weight": 0.001056739573778828,
		"wff_gun_retailers_weight": 0.0031800941049025867,
		"wff_civ_weight": 0.004236833678681415,
		"wff_major_military_contractors_weight": 0.044728902597009734,
		"wff_cluster_munitions_weight": 0.00915948605219932,
		"wff_nuclear_weapons_weight": 0.02238640675339141,
		"wff_mil_weight": 0.044728902597009734,
		"t_weight": 0.002156948228905572,
		"t_m_weight": 0.0036814409076013723,
		"t_all_weight": 0.005838389136506945,
		"pff_all_weight": 0.10964482164511313,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.008736533039582937,
		"gef_score": 53.37283414905435,
		"gef_grp_norm": 31.91800878477306,
		"gef_percent_rated": 0.8579700044133386,
		"fossil_bank_score": 10.1948,
		"fossil_insure_score": 14.8124,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 3,
		"type": "default"
	},
	"FOUSA068A0": {
		"investment_vehicle_name": "T. Rowe Price Retirement 2050",
		"fund_id": "FSUSA07VNR",
		"ticker": "TRRMX",
		"fund_legal_name": "T. Rowe Price Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "T. Rowe Price Retirement Series",
		"fund_family_label": "T. Rowe Price",
		"portfolio_date": "2025-02-28",
		"net_assets": 16176189402,
		"percent_rated": 0.9455360982631977,
		"percent_rated_long": 0.9498581641554301,
		"sustainable_investment": 0,
		"ff_all_weight": 0.09940599349515815,
		"c2_weight": 0.03547856748463019,
		"mc50_weight": 0.009335520611889166,
		"df_p_weight": 0.006752836246614828,
		"df_f_weight": 0.02730123667048142,
		"df_c_weight": 0.07197660274289731,
		"wff_gun_manufacturers_weight": 0.001056739573778828,
		"wff_gun_retailers_weight": 0.0031800941049025867,
		"wff_civ_weight": 0.004236833678681415,
		"wff_major_military_contractors_weight": 0.044728902597009734,
		"wff_cluster_munitions_weight": 0.00915948605219932,
		"wff_nuclear_weapons_weight": 0.02238640675339141,
		"wff_mil_weight": 0.044728902597009734,
		"t_weight": 0.002156948228905572,
		"t_m_weight": 0.0036814409076013723,
		"t_all_weight": 0.005838389136506945,
		"pff_all_weight": 0.10964482164511313,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.008736533039582937,
		"gef_score": 53.37283414905435,
		"gef_grp_norm": 31.91800878477306,
		"gef_percent_rated": 0.8579700044133386,
		"fossil_bank_score": 10.1948,
		"fossil_insure_score": 14.8124,
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 3,
		"type": "default"
	},
	"F00000T8XK": {
		"investment_vehicle_name": "State Street Target Retirement 2050 K",
		"fund_id": "FS0000AREA",
		"ticker": "SSDLX",
		"fund_legal_name": "State Street Target Retirement 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "State Street Target Retirement Series",
		"fund_family_label": "State Street",
		"portfolio_date": "2025-01-31",
		"net_assets": 2255955483,
		"percent_rated": 0.8351033635238997,
		"percent_rated_long": 0.8351033635238997,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07450969980880906,
		"c2_weight": 0.025810010731171593,
		"mc50_weight": 0.008715553787604077,
		"df_p_weight": 0.004427727005656303,
		"df_f_weight": 0.026404986094311116,
		"df_c_weight": 0.0647812141511913,
		"wff_gun_manufacturers_weight": 0.0005933264762089107,
		"wff_gun_retailers_weight": 0.003197114513434538,
		"wff_civ_weight": 0.0037904409896434483,
		"wff_major_military_contractors_weight": 0.02979915766625578,
		"wff_cluster_munitions_weight": 0.010786235748165798,
		"wff_nuclear_weapons_weight": 0.01677758327697699,
		"wff_mil_weight": 0.02979915766625578,
		"t_weight": 0.004157456871511734,
		"t_m_weight": 0.005454579050129782,
		"t_all_weight": 0.009612035921641516,
		"pff_all_weight": 0.08394235962489674,
		"pff_extreme_weight": 0.00022982620308945812,
		"pff_high_weight": 0.008475760728553708,
		"gef_score": 52.777523120522766,
		"gef_grp_norm": 16.251830161054173,
		"gef_percent_rated": 0.7092079754096929,
		"fossil_bank_score": 13.9553,
		"fossil_insure_score": 12.9954,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 5,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"type": "default"
	},
	"FOUSA06BBH": {
		"investment_vehicle_name": "Trillium ESG Global Equity Institutional",
		"fund_id": "FSUSA004DN",
		"ticker": "PORIX",
		"fund_legal_name": "Trillium ESG Global Equity Fund",
		"category_group": "International Equity Funds",
		"morningstar_category_name": "Global Large-Stock Blend",
		"strategy_name": "Trillium ESG Global Equity",
		"fund_family_label": "Trillium Mutual Funds",
		"portfolio_date": "2025-02-28",
		"net_assets": 833577871,
		"percent_rated": 0.9923157425084764,
		"percent_rated_long": 0.9923157425084764,
		"sustainable_investment": 1,
		"ff_all_weight": 0.012594639763415696,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0,
		"df_f_weight": 0,
		"df_c_weight": 0.11254249454517969,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0,
		"wff_cluster_munitions_weight": 0,
		"wff_nuclear_weapons_weight": 0,
		"wff_mil_weight": 0,
		"t_weight": 0,
		"t_m_weight": 0,
		"t_all_weight": 0,
		"pff_all_weight": 0.13920881304201513,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0,
		"gef_score": 58.23532191840323,
		"gef_grp_norm": 83.45521023765995,
		"gef_percent_rated": 0.9487801938062724,
		"fossil_bank_score": 3.294,
		"fossil_insure_score": 16.8862,
		"grade_fossil": 2,
		"grade_fossil_bank": 2,
		"grade_fossil_insure": 4,
		"grade_deforestation": 1.5,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 2,
		"grade_military": 1,
		"grade_tobacco": 1,
		"type": "equity"
	},
	"F000002Q7W": {
		"investment_vehicle_name": "American Funds 2050 Trgt Date Retire R6",
		"fund_id": "FSUSA07X4H",
		"ticker": "RFITX",
		"fund_legal_name": "American Funds 2050 Target Date Retirement Fund®",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "Capital American Target Date Retirement Series",
		"fund_family_label": "American Funds/Capital Group",
		"portfolio_date": "2024-12-31",
		"net_assets": 34190901357,
		"percent_rated": 0.8669430253695459,
		"percent_rated_long": 0.8687663628716421,
		"sustainable_investment": 0,
		"ff_all_weight": 0.06408538763120512,
		"c2_weight": 0.02253825245326073,
		"mc50_weight": 0.0006993672943170521,
		"df_p_weight": 0.003503929311897421,
		"df_f_weight": 0.018376126499130938,
		"df_c_weight": 0.05654266179664179,
		"wff_gun_manufacturers_weight": 0.0022242793728604504,
		"wff_gun_retailers_weight": 0.00003930043662789908,
		"wff_civ_weight": 0.0022635798094883496,
		"wff_major_military_contractors_weight": 0.05587797560232653,
		"wff_cluster_munitions_weight": 0.029225992745110483,
		"wff_nuclear_weapons_weight": 0.039539831987341775,
		"wff_mil_weight": 0.05587797560232653,
		"t_weight": 0.018864391591186858,
		"t_m_weight": 0.003981845513996949,
		"t_all_weight": 0.022846237105183808,
		"pff_all_weight": 0.12474522005235991,
		"pff_extreme_weight": 0,
		"pff_high_weight": 0.018531237390946947,
		"gef_score": 53.718733565070096,
		"gef_grp_norm": 43.04538799414349,
		"gef_percent_rated": 0.7809264102295893,
		"fossil_bank_score": 7.5597,
		"fossil_insure_score": 5.7347,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_tobacco": 5,
		"type": "default"
	},
	"F00000MAPG": {
		"investment_vehicle_name": "BlackRock LifePath® Index 2050 K",
		"fund_id": "FSUSA0BDPU",
		"ticker": "LIPKX",
		"fund_legal_name": "BlackRock LifePath® Index 2050 Fund",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "BlackRock LifePath Index",
		"fund_family_label": "BlackRock/iShares",
		"portfolio_date": "2025-02-28",
		"net_assets": 9671393861,
		"percent_rated": 0.9216219901899001,
		"percent_rated_long": 0.9301073604272917,
		"sustainable_investment": 0,
		"ff_all_weight": 0.08313529288894668,
		"c2_weight": 0.02804313395790369,
		"mc50_weight": 0.012616967980786303,
		"df_p_weight": 0.004483709397129805,
		"df_f_weight": 0.030035856955540268,
		"df_c_weight": 0.08272055642868363,
		"wff_gun_manufacturers_weight": 0.0007550691106988141,
		"wff_gun_retailers_weight": 0.00450526949500619,
		"wff_civ_weight": 0.005260338605705004,
		"wff_major_military_contractors_weight": 0.032551509426526855,
		"wff_cluster_munitions_weight": 0.012363630776441549,
		"wff_nuclear_weapons_weight": 0.019403434217555828,
		"wff_mil_weight": 0.032551509426526855,
		"t_weight": 0.005162364459874153,
		"t_m_weight": 0.0071533100546623644,
		"t_all_weight": 0.012315674514536518,
		"pff_all_weight": 0.12014136095437689,
		"pff_extreme_weight": 0.00018864596199702087,
		"pff_high_weight": 0.010626949228012439,
		"gef_score": 53.85183239871504,
		"gef_grp_norm": 50.07320644216691,
		"gef_percent_rated": 0.8171760511224829,
		"fossil_bank_score": 15.7909,
		"fossil_insure_score": 16.9224,
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"type": "default"
	},
	"STSP0L2050": {
		"investment_vehicle_name": "L 2050",
		"fund_id": "FTSP0L2050",
		"ticker": null,
		"fund_legal_name": "L 2050",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Target-Date 2050",
		"strategy_name": "TSP Lifecycle Funds",
		"fund_family_label": "Thrift Savings Plan",
		"portfolio_date": "2024-10-01",
		"net_assets": 38800000000,
		"percent_rated": 0.8049174490348288,
		"percent_rated_long": 0.8089737174520446,
		"sustainable_investment": 0,
		"ff_all_weight": 0.07545041547155636,
		"c2_weight": 0.029129201714750523,
		"mc50_weight": 0.01083895260412518,
		"df_p_weight": 0.004708339092042486,
		"df_f_weight": 0.03478097027449047,
		"df_c_weight": 0.0825549942063268,
		"wff_gun_manufacturers_weight": 0.0006884716836485544,
		"wff_gun_retailers_weight": 0.0036056801674765413,
		"wff_civ_weight": 0.004294151851125095,
		"wff_major_military_contractors_weight": 0.031998161765823104,
		"wff_cluster_munitions_weight": 0.013799282790740266,
		"wff_nuclear_weapons_weight": 0.018617226788189323,
		"wff_mil_weight": 0.031998161765823104,
		"t_weight": 0.005506811670358576,
		"t_m_weight": 0.00726879321046606,
		"t_all_weight": 0.012775604880824637,
		"pff_all_weight": 0.10338760952922099,
		"pff_extreme_weight": 0.0001794108294043467,
		"pff_high_weight": 0.010280888261364503,
		"gef_score": 54.369301321294465,
		"gef_grp_norm": 68.66764275256223,
		"gef_percent_rated": 0.7933847614274019,
		"fossil_bank_score": 14.8217,
		"fossil_insure_score": 17.7818,
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 4,
		"type": "default"
	},
	"STIAA00019": {
		"investment_vehicle_name": "CREF Social Choice Account (R3)",
		"fund_id": "FTIAA00005",
		"ticker": "QCSCIX",
		"fund_legal_name": "CREF Social Choice Account",
		"category_group": "Allocation Funds",
		"morningstar_category_name": "Moderate Allocation",
		"strategy_name": "TIAA CREF Variable Annuities",
		"fund_family_label": "TIAA Investments/Nuveen",
		"portfolio_date": "2024-10-31",
		"net_assets": 21314154893,
		"percent_rated": 0.5895403826414937,
		"percent_rated_long": 0.5895462332188894,
		"sustainable_investment": 1,
		"ff_all_weight": 0.018501446644174083,
		"c2_weight": 0,
		"mc50_weight": 0,
		"df_p_weight": 0.0030203041340077143,
		"df_f_weight": 0.022242258472394652,
		"df_c_weight": 0.06445596613975373,
		"wff_gun_manufacturers_weight": 0,
		"wff_gun_retailers_weight": 0,
		"wff_civ_weight": 0,
		"wff_major_military_contractors_weight": 0.01584629035683929,
		"wff_cluster_munitions_weight": 0.0008595509077036034,
		"wff_nuclear_weapons_weight": 0.005059851036390291,
		"wff_mil_weight": 0.01584629035683929,
		"t_weight": 0,
		"t_m_weight": 0.009806825589856183,
		"t_all_weight": 0.009806825589856183,
		"pff_all_weight": 0.059592578883626526,
		"pff_extreme_weight": 0.0005049082290300437,
		"pff_high_weight": 0.0017496424839541897,
		"gef_score": 56.842930602267934,
		"gef_grp_norm": 97.65739385065886,
		"gef_percent_rated": 0.5875711810320977,
		"fossil_bank_score": 8.3816,
		"fossil_insure_score": 10.2147,
		"grade_fossil": 2,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_guns": 1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 3,
		"grade_tobacco": 2,
		"type": "default"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/PlanOptions.json
// module id = 1008
// module chunks = 0